export const sharedMessages = {
  headerLangSwitcher: {
    id: 'header.lang-switcher',
    defaultMessage: 'Eesti',
    description: 'Locale switcher label in header',
  },
  headerRegisterOrLoginButton: {
    id: 'header.register-or-login-button',
    defaultMessage: 'Register/Login',
    description: 'Text for register/login button in header',
  },
  headerLogoutButtonLabel: {
    id: 'header.logout-button-label',
    defaultMessage: 'Log out',
    description: 'Text for logout button in header',
  },
  headerLoginButtonLabel: {
    id: 'header.login-button-label',
    defaultMessage: 'Welcome',
    description: 'Text for welcome auth user on the page',
  },
  headerGuestUser: {
    id: 'header.guest-user',
    defaultMessage: 'User',
    description: 'Text for welcome non-auth user on the page',
  },
  ticketBannerTitle: {
    id: 'ticket.banner.title',
    defaultMessage: 'THANK YOU!',
    description: "Ticket's page banner title",
  },
  ticketBannerBody: {
    id: 'ticket.banner.body',
    defaultMessage:
      "Your payment has been successful and confirmation has been sent to your email. Click on 'Download' to access your ticket and booking.",
    description: "Ticket's page banner body",
  },
  bannerClose: {
    id: 'banner.close',
    defaultMessage: 'Close banner',
    description: 'Accessible name of the close button of a banner',
  },
  ticketQrCodeAlt: {
    id: 'ticket.qr-code-alt',
    defaultMessage: 'ticket qr code',
    description: 'Alternative text of the QR code image of a sail on the ticket',
  },
  ticketBannerErrorTitle: {
    id: 'ticket.error-banner.title',
    defaultMessage: 'WARNING',
    description: "Ticket's page error-banner title",
  },
  ticketBannerErrorBody: {
    id: 'ticket.error-banner.body',
    defaultMessage:
      'The server throws random errors with no specific codes. let’s pretend it’s aliens invasion, please reboot the Earth!',
    description: "Ticket's page error-banner body",
  },
  ticketReservationLoadErrorTitle: {
    id: 'ticket.reservation-load-error.title',
    defaultMessage: 'Reservation not found',
    description: 'Title shown when reservation details cannot be loaded',
  },
  ticketReservationLoadErrorBody: {
    id: 'ticket.reservation-load-error.body',
    defaultMessage: 'Cannot load reservation details.',
    description: 'Body shown when reservation details cannot be loaded',
  },
  ticketActionButtonsPrint: {
    id: 'ticket.action-buttons.print',
    defaultMessage: 'Print out',
    description: 'Label for print action button',
  },
  ticketActionButtonsDownload: {
    id: 'ticket.action-buttons.download',
    defaultMessage: 'Download',
    description: 'Label for download action button',
  },
  ticketActionButtonsCancel: {
    id: 'ticket.action-buttons.cancel',
    defaultMessage: 'Cancel',
    description: 'Label for cancel action button',
  },
  ticketConfirmationSuccessfulBooking: {
    id: 'ticket.confirmation-successful-booking',
    defaultMessage: 'Confirmation of successful booking',
    description: 'Label for confirmation of successful booking',
  },
  ticketInfoCancelledBooking: {
    id: 'ticket.info-cancelled-booking',
    defaultMessage: 'Cancelled booking nr',
    description: 'Label for cancelled booking',
  },
  ticketActionButtonsEdit: {
    id: 'ticket.action-buttons.edit',
    defaultMessage: 'Edit',
    description: 'Label for edit action button',
  },
  ticketPrintedTicketNumber: {
    id: 'ticket.printed-ticket.number',
    defaultMessage: 'Ticket No:',
    description: 'Ticket number label',
  },
  ticketPrintedTicketVehicleNumberLabel: {
    id: 'ticket.printed-ticket.vehicle-number-label',
    defaultMessage: 'Vehicle reg. No',
    description: 'Vehicle number label',
  },
  cancelAndRemoveTicket: {
    id: 'reservation-refund.cancel-remove-title',
    defaultMessage: 'Cancel and remove E-ticket nr.',
    description: 'label for cancelAndRemoveTicket',
  },
  amountRefundTip: {
    id: 'reservation-refund.amount-refund-tip',
    defaultMessage:
      '* - will be refunded to you by the means on MPAY service, using same payment gateway that you chosen while purchasing the ticket(s).',
    description: 'label for amountRefundTip(maritime)',
  },
  amountPaid: {
    id: 'reservation-refund.amount-paid',
    defaultMessage: "Amount you've paid:",
    description: 'label for amountPaid',
  },
  percentRefund: {
    id: 'reservation-refund.percent-refund',
    defaultMessage: 'Percent of refund:',
    description: 'label for percentRefund',
  },
  amountRefund: {
    id: 'reservation-refund.amount-refund',
    defaultMessage: 'Amount to be refund:',
    description: 'label for amountRefund',
  },
  refundCancelError: {
    id: 'reservation-refund.cancel-error',
    defaultMessage: 'The ticket could not be cancelled. Please try again or contact our Customer Support.',
    description: 'error banner when confirming the ticket cancellation fails',
  },
  refundAgreement: {
    id: 'reservation-refund.refund-agreement',
    defaultMessage:
      "Yes, I want to cancel and remove this E-ticket and I'm agree to receive above mentioned amount as per Service Provider Agreement.",
    description: 'label for refundAgreement',
  },
  cancelRouteRefund: {
    id: 'reservation-refund.cancel-route',
    defaultMessage: 'Cancel this route',
    description: 'label for cancelRoute',
  },
  cancelled: {
    id: 'reservation-refund.sail-cancelled',
    defaultMessage: 'cancelled by customer',
    description: 'label for cancelled by customer',
  },
  cancelledSail: {
    id: 'reservation-refund.sailref-cancelled',
    defaultMessage: 'cancelled',
    description: 'label for cancelled admin',
  },
  ticketWasRefundTipMaritime: {
    id: 'reservation-refund.was-refund-tip-maritime',
    defaultMessage:
      'Amount of <b>{refundAmount}</b> will be returned to you by the means on MPAY service, using same payment gateway that you chosen while purchasing the ticket(s). If the refund was not received within 7 working days to your bank account please contact our Customer Support',
    description: 'label for ticketWasRefundTip',
  },
  mayClose: {
    id: 'reservation-refund.may-close',
    defaultMessage: 'You may close this window now.',
    description: 'label for mayClose',
  },
  ticketTripWasRefund: {
    id: 'reservation-refund.trip-was-refund',
    defaultMessage: 'Your {route} trip on {dateTime} (ticket No. {reservationId}) is successfully cancelled.',
    description: 'result of cancelling one direction of a round trip',
  },
  ticketWasRefund: {
    id: 'reservation-refund.was-refund',
    defaultMessage: 'Your ticket nr. <b>{reservationId}</b> is successfully cancelled / deleted',
    description: 'label for ticketWasRefund',
  },

  newsPageTitle: {
    id: 'news-page.title',
    defaultMessage: 'Notifications',
    description: 'Notifications',
  },

  tariffsPageTitle: {
    id: 'tariffs-page.title',
    defaultMessage: 'Tariffs',
    description: 'Tariffs',
  },

  profilePageTitle: {
    id: 'profile-page.title',
    defaultMessage: 'Profile',
    description: 'Profile',
  },

  schedulePageTableDepartureTime: {
    id: 'schedule-page.table.departure-time',
    defaultMessage: 'Departure Time',
    description: 'Departure Time',
  },
  searchBarWherePlaceholder: {
    id: 'search-bar.where-placeholder',
    defaultMessage: 'Choose route',
    description: 'Choose route',
  },

  mainViewRouteSelectionHeader: {
    id: 'main-view.route-selection-header',
    defaultMessage: 'Or select route',
    description: 'Or select route',
  },

  searchBarWhenPlaceholder: {
    id: 'search-bar.when-placeholder',
    defaultMessage: 'Pick a date from calendar',
    description: 'Pick a date from calendar',
  },

  footerCopyright: {
    id: 'footer.copyright',
    defaultMessage: 'Tuule Liinid OÜ | Powered by Bora Systems',
    description: 'Tuule Liinid OÜ | Powered by Bora Systems',
  },
  bookTicketBadgeTitle: {
    id: 'book-ticket.badge.title',
    defaultMessage: 'Book Ticket',
    description: 'Book Ticket',
  },
  userNotExist: {
    id: 'auth.signin-failed-user-not-exist',
    defaultMessage: 'User does not exist',
    description: 'Error on Forgot password tab',
  },
  userNotValid: {
    id: 'auth.signin-failed-user-not-valid',
    defaultMessage: 'Email or Mobile number or Password is Incorrect. Please try again',
    description: 'Error on Forgot password tab',
  },
  passwordResetSuccess: {
    id: 'auth.password-reset-success',
    defaultMessage: 'Password has been reset successfully',
    description: 'Success message after password reset',
  },
  forgotPassHeaderTitle: {
    id: 'login.sign-forgot-pass-header-title',
    defaultMessage: 'Forgot password',
    description: 'Forgot password',
  },
  requiredError: {
    id: 'common-fields.required-error',
    defaultMessage: 'Required',
    description: 'Required',
  },
  recoverySendButton: {
    id: 'recovery.send-button',
    defaultMessage: 'Send',
    description: 'Send',
  },
  invalidFormatText: {
    id: 'invalid-format-text',
    defaultMessage: 'Invalid format',
    description: 'Invalid format',
  },
  passengersData: {
    id: 'passengers-data.label',
    defaultMessage: 'Passengers and Groups',
    description: 'Passengers and Groups',
  },
  cookiesCollect: {
    id: 'cookie-banner-description',
    defaultMessage: '{url} website uses cookies. By continuing to use this website you agree to our to our',
    description: 'Collecting Cookies label',
  },
  privacyPolicy: {
    id: 'privacy-policy',
    defaultMessage: 'Privacy Policy',
    description: 'Privacy Policy',
  },
  cookiesAgreement: {
    id: 'agree-privacy-policy',
    defaultMessage: 'Agree',
    description: 'Agreement button',
  },
  customerInformationEdit: {
    id: 'customer-information-edit',
    defaultMessage: 'Edit',
    description: 'Edit button',
  },
  customerInformationSave: {
    id: 'customer-information-save',
    defaultMessage: 'Save',
    description: 'Save button',
  },
  customerInformationCancel: {
    id: 'customer-information-cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button',
  },
  customerInformationFistName: {
    id: 'label.customer-information-firstname',
    defaultMessage: 'First Name',
    description: 'First Name label',
  },
  customerInformationLastName: {
    id: 'label.customer-information-lastname',
    defaultMessage: 'Last Name',
    description: 'Last Name label',
  },
  customerInformationPhone: {
    id: 'label.customer-information-phone',
    defaultMessage: 'Phone number',
    description: 'Phone number label',
  },
  customerInformationEmail: {
    id: 'label.customer-information-email',
    defaultMessage: 'E-mail',
    description: 'E-mail label',
  },

  searchBarWhereLabel: {
    id: 'search-bar.where-label',
    defaultMessage: 'Where',
    description: 'Where',
  },
  searchBarWhenLabel: {
    id: 'search-bar.when-label',
    defaultMessage: 'When',
    description: 'When',
  },

  searchBarRoundTrip: {
    id: 'search-bar.round-trip',
    defaultMessage: 'Round-Trip',
    description: 'Round-Trip',
  },

  searchBarGetTickets: {
    id: 'search-bar.get-tickets',
    defaultMessage: 'Get Tickets',
    description: 'Get Tickets',
  },
  signInEnter: {
    id: 'sign-in.enter',
    defaultMessage: 'Enter',
    description: 'Enter',
  },
  authSignupWithIdKaart: {
    id: 'auth.signup-with-id-kaart',
    defaultMessage: 'SIGN UP WITH ID-KAART',
    description: 'SIGN UP WITH ID-KAART',
  },
  authSignupWithMobiilId: {
    id: 'auth.signup-with-mobiil-id',
    defaultMessage: 'SIGN UP WITH MOBIIL-ID',
    description: 'SIGN UP WITH MOBIIL-ID',
  },
  authSignupWithSmartId: {
    id: 'auth.signup-with-smart-id',
    defaultMessage: 'SIGN UP WITH SMART-ID',
    description: 'SIGN UP WITH SMART-ID',
  },
  authSigninWithIdKaart: {
    id: 'auth.signin-with-id-kaart',
    defaultMessage: 'SIGN IN WITH ID-KAART',
    description: 'SIGN IN WITH ID-KAART',
  },
  authSigninWithMobiilId: {
    id: 'auth.signin-with-mobiil-id',
    defaultMessage: 'SIGN IN WITH MOBIIL-ID',
    description: 'SIGN IN WITH MOBIIL-ID',
  },
  authSigninWithSmartId: {
    id: 'auth.signin-with-smart-id',
    defaultMessage: 'SIGN IN WITH SMART-ID',
    description: 'SIGN IN WITH SMART-ID',
  },
  authMethodIdKaart: {
    id: 'auth.method.id-kaart',
    defaultMessage: 'ID-kaart',
    description: 'authorisation by ID-kaart',
  },
  authMethodMobiilId: {
    id: 'auth.method.mobiil-id',
    defaultMessage: 'Mobiil-ID',
    description: 'authorisation by Mobiil-ID',
  },
  authMethodSmartId: {
    id: 'auth.method.smart-id',
    defaultMessage: 'Smart-ID',
    description: 'authorisation by Smart-ID',
  },
  authMethodEpost: {
    id: 'auth.method.e-post',
    defaultMessage: 'E-post',
    description: 'authorisation by email',
  },
  authCreateAccount: {
    id: 'auth.create-account',
    defaultMessage: 'Loo konto',
    description: 'Create account button',
  },
  authCreateAccountTitle: {
    id: 'auth.create-account-title',
    defaultMessage: 'Loo oma konto',
    description: 'Create your account page title',
  },
  authYourData: {
    id: 'auth.your-data',
    defaultMessage: 'Sinu andmed',
    description: 'Your data section title',
  },
  authTermsAgreement: {
    id: 'auth.terms-agreement',
    defaultMessage: 'Olen lugenud ja nõustun',
    description: 'Terms agreement checkbox text',
  },
  authTermsLink: {
    id: 'auth.terms-link',
    defaultMessage: 'kasutustingimustega',
    description: 'Terms of use link text',
  },
  authAlreadyHaveAccount: {
    id: 'auth.already-have-account',
    defaultMessage: 'Kas Sul on juba konto?',
    description: 'Already have account text',
  },
  authLogInLink: {
    id: 'auth.log-in-link',
    defaultMessage: 'Logi sisse.',
    description: 'Log in link text',
  },
  authComingSoon: {
    id: 'auth.coming-soon',
    defaultMessage: 'Tulemas',
    description: 'Coming soon placeholder for Estonian auth methods',
  },
  authRegistrationBenefitsIntro: {
    id: 'auth.registration-benefits-intro',
    defaultMessage:
      'Kasutajakonto võimaldab sul mugavalt vaadata ja hallata oma pileteid ning broneeringuid ühes kohas. Saad kiiresti ülevaate aktiivsetest ostudest ja varasemast ostuajaloost – lihtsalt ja turvaliselt.',
    description: 'Registration benefits intro text',
  },
  authRegistrationBenefitsTitle: {
    id: 'auth.registration-benefits-title',
    defaultMessage: 'Registreerudes saad:',
    description: 'Registration benefits list title',
  },
  authBenefitViewTickets: {
    id: 'auth.benefit-view-tickets',
    defaultMessage: 'vaadata ja hallata oma aktiivseid pileteid ja broneeringuid',
    description: 'Benefit: view and manage tickets',
  },
  authBenefitOrderHistory: {
    id: 'auth.benefit-order-history',
    defaultMessage: 'näha varasemaid oste ja tellimuste ajalugu',
    description: 'Benefit: order history',
  },
  authBenefitSaveData: {
    id: 'auth.benefit-save-data',
    defaultMessage: 'salvestada andmed kiiremaks edasisekas ostuks',
    description: 'Benefit: save data for faster purchases',
  },
  authBenefitReceipts: {
    id: 'auth.benefit-receipts',
    defaultMessage: 'laadida alla kviitiungeid ja ostudokumente',
    description: 'Benefit: download receipts',
  },
  authBenefitBusinessAccount: {
    id: 'auth.benefit-business-account',
    defaultMessage: 'hallata ettevõtte kontot ja teha oste ärikliendina',
    description: 'Benefit: manage business account',
  },
  authNoAccount: {
    id: 'auth.no-account',
    defaultMessage: 'Pole kontot?',
    description: 'No account? text on login page',
  },
  authRegisterLink: {
    id: 'auth.register-link',
    defaultMessage: 'Registreeru.',
    description: 'Register link text on login page',
  },
  authFieldEmailLabel: {
    id: 'auth.field-email-label',
    defaultMessage: 'E-posti aadress',
    description: 'Email field label on signup form',
  },
  authFieldPasswordLabel: {
    id: 'auth.field-password-label',
    defaultMessage: 'Salasõna',
    description: 'Password field label on signup form',
  },
  authFieldPlaceholder: {
    id: 'auth.field-placeholder',
    defaultMessage: 'Kohustuslik',
    description: 'Required field placeholder on signup form',
  },
  authPasswordRulesPrefix: {
    id: 'auth.password-rules-prefix',
    defaultMessage: 'Vähemalt',
    description: 'Password rules prefix: "At least"',
  },
  authPasswordRuleMinLength: {
    id: 'auth.password-rule-min-length',
    defaultMessage: '8 tähemärki',
    description: 'Password rule: 8 characters',
  },
  authPasswordRuleUppercase: {
    id: 'auth.password-rule-uppercase',
    defaultMessage: '1 suurtäht',
    description: 'Password rule: 1 uppercase letter',
  },
  authPasswordRuleNumber: {
    id: 'auth.password-rule-number',
    defaultMessage: '1 number',
    description: 'Password rule: 1 number',
  },
  authPasswordRuleSpecial: {
    id: 'auth.password-rule-special',
    defaultMessage: '1 erimärk',
    description: 'Password rule: 1 special character',
  },
  authCheckMailboxTitle: {
    id: 'auth.check-mailbox-title',
    defaultMessage: 'Palun, kontrolli oma postkasti',
    description: 'Check your mailbox title after signup',
  },
  authActivationLinkSent: {
    id: 'auth.activation-link-sent',
    defaultMessage:
      'Aktiveerimislingi on <strong>saadetud teie e-posti aadressile</strong>. Pärast edukat kinnitamist saate oma kontot kasutama hakata.',
    description: 'Activation link sent to email message',
  },
  invalidPasswordText: {
    id: 'invalid-password-text',
    defaultMessage: 'Vähemalt 8 tähemärki, 1 suurtäht, 1 number, 1 erimärk',
    description: 'password validation',
  },
  confirmationTicketType: {
    id: 'confirmation.ticket-type',
    defaultMessage: 'Ticket type',
    description: 'Ticket type',
  },
  confirmationQty: {
    id: 'confirmation.qty',
    defaultMessage: 'Qty',
    description: 'Qty',
  },
  confirmationPrice: {
    id: 'confirmation.price',
    defaultMessage: 'Price',
    description: 'Price',
  },
  confirmationVAT: {
    id: 'confirmation.VAT',
    defaultMessage: 'VAT (5%)',
    description: 'VAT',
  },
  confirmationSubtotal: {
    id: 'confirmation.subtotal',
    defaultMessage: 'Subtotal',
    description: 'Subtotal',
  },
  confirmationSubtotalFull: {
    id: 'confirmation.subtotal-full',
    defaultMessage: 'Subtotal without VAT',
    description: 'Subtotal without VAT',
  },
  confirmationTotal: {
    id: 'confirmation.total',
    defaultMessage: 'TOTAL TO PAY:',
    description: 'TOTAL TO PAY:',
  },
  confirmationTotalFull: {
    id: 'confirmation.total-full',
    defaultMessage: 'TOTAL TO PAY:',
    description: 'TOTAL TO PAY:',
  },
  confirmationDescription: {
    id: 'confirmation.description',
    defaultMessage: 'Description',
    description: 'Description',
  },

  confirmationOnlineChargesLabel: {
    id: 'confirmation.online-charges-label',
    defaultMessage: 'Online Charges',
    description: 'Online Charges',
  },

  confirmationTermsAndConditionsTermsQuestions: {
    id: 'confirmation.terms-and-conditions.terms-question',
    defaultMessage: 'I hereby agree to the below Terms and Conditions',
    description: 'I hereby agree to the below Terms and Conditions',
  },

  confirmationCarWidthOver2: {
    id: 'confirmation.customer-info.car-width-over-2',
    defaultMessage: 'More than 2m',
    description: 'More than 2m',
  },

  confirmationPaymentWarning: {
    id: 'confirmation.payment-warning',
    defaultMessage: 'You must agree to terms of services to proceed',
    description: 'You must agree to terms of services to proceed',
  },

  confirmationContactFormCustomerInformation: {
    id: 'confirmation.contact-form.customer-information',
    defaultMessage: 'Customer information',
    description: 'Customer information',
  },

  confirmationContactFormFirstName: {
    id: 'confirmation.contact-form.first-name',
    defaultMessage: 'Name',
    description: 'Name',
  },

  confirmationContactFormLastName: {
    id: 'confirmation.contact-form.last-name',
    defaultMessage: 'Surname',
    description: 'Surname',
  },

  confirmationContactFormEmail: {
    id: 'confirmation.contact-form.e-mail',
    defaultMessage: 'E-mail',
    description: 'E-mail',
  },

  confirmationContactFormPhoneNumber: {
    id: 'confirmation.contact-form.phoneNumber',
    defaultMessage: 'Mob. phone No.',
    description: 'Mob. phone No.',
  },

  confirmationContactFormPhoneRequiredError: {
    id: 'confirmation.contact-form.required-error',
    defaultMessage: 'Required',
    description: 'Required',
  },

  confirmationContactFormInvalidFormatError: {
    id: 'confirmation.contact-form.invalid-format-error',
    defaultMessage: 'Invalid format',
    description: 'Invalid format',
  },

  confirmationContactFormInvalidEmailError: {
    id: 'confirmation.contact-form.invalid-email-format-error',
    defaultMessage: 'Invalid email address',
    description: 'Invalid email address',
  },

  confirmationContactFormFirstNamePlaceHolder: {
    id: 'confirmation.contact-form.first-name-placeholder',
    defaultMessage: 'Type your first name here',
    description: 'Type your first name here',
  },

  confirmationContactFormLastNamePlaceHolder: {
    id: 'confirmation.contact-form.last-name-placeholder',
    defaultMessage: 'Type your last name here',
    description: 'Type your last name here',
  },

  confirmationContactFormEmailPlaceHolder: {
    id: 'confirmation.contact-form.email-placeholder',
    defaultMessage: 'Type your e-mail here',
    description: 'Type your e-mail here',
  },

  confirmationContactFormCodePlaceHolder: {
    id: 'confirmation.contact-form.code-placeholder',
    defaultMessage: '+372',
    description: 'Code PlaceHolder',
  },

  confirmationContactFormPhonePlaceHolder: {
    id: 'confirmation.contact-form.phone-placeholder',
    defaultMessage: '123456789',
    description: 'Phone PlaceHolder',
  },

  // Company form translations
  confirmPageCompanyDetails: {
    id: 'confirm-page.company-details',
    defaultMessage: 'Company details',
    description: 'Company details section header',
  },

  confirmPageCompanyName: {
    id: 'confirm-page.company-name',
    defaultMessage: 'Company name',
    description: 'Company name label',
  },

  confirmPageErrorMessage: {
    id: 'confirm-page.error-message',
    defaultMessage: 'Invalid format',
    description: 'Invalid format error message',
  },

  confirmPageRequiredField: {
    id: 'confirm-page.required-field',
    defaultMessage: 'Required field',
    description: 'Required field error message',
  },

  confirmPagePrivatePersonTab: {
    id: 'confirm-page.private-person-tab',
    defaultMessage: 'Private person',
    description: 'Private person tab label',
  },

  confirmPageCompanyTab: {
    id: 'confirm-page.company-tab',
    defaultMessage: 'Company',
    description: 'Company tab label',
  },

  confirmationChooseRole: {
    id: 'confirmation.contact-form.choose-role',
    defaultMessage: 'Choose role',
    description: 'Role selector label for authorized users',
  },

  confirmationChooseRolePrivatePersonText: {
    id: 'confirmation.contact-form.choose-role-private-person-text',
    defaultMessage: '(Private person)',
    description: 'Private person label in role selector dropdown',
  },

  confirmationChooseRoleCompanyText: {
    id: 'confirmation.contact-form.choose-role-company-text',
    defaultMessage: '(Company representer)',
    description: 'Company representer label in role selector dropdown',
  },

  confirmationChooseRoleCreditCompanyText: {
    id: 'confirmation.contact-form.choose-role-credit-company-text',
    defaultMessage: '(Contract representer)',
    description: 'Credit/contract company label in role selector dropdown',
  },

  confirmationPayWithCreditButtonText: {
    id: 'confirmation.pay-with-credit-button-text',
    defaultMessage: 'Payment from company account',
    description: 'Credit payment button label',
  },

  confirmPageOr: {
    id: 'confirm-page.or',
    defaultMessage: 'OR',
    description: 'OR separator between credit payment and regular payment methods',
  },

  confirmationPayWithCreditLimitButtonText: {
    id: 'confirmation.pay-with-credit-limit-button-text',
    defaultMessage: 'Balance:',
    description: 'Credit balance label below credit payment button',
  },

  confirmPageNotEnoughCredit: {
    id: 'confirm-page.not-enough-credit',
    defaultMessage: 'Not enough credit. Your balance: {amount}',
    description: 'Message when credit balance is insufficient for payment',
  },

  confirmPageRegistrationCode: {
    id: 'confirm-page.registration-code',
    defaultMessage: 'Registration code',
    description: 'Company registration code label',
  },

  confirmPageLegalAddress: {
    id: 'confirm-page.legal-address',
    defaultMessage: 'Legal address',
    description: 'Company legal address label',
  },

  confirmPagePostalCode: {
    id: 'confirm-page.postal-code',
    defaultMessage: 'Postal code',
    description: 'Postal code label',
  },

  confirmPageCity: {
    id: 'confirm-page.city',
    defaultMessage: 'City',
    description: 'City label',
  },

  confirmPageCountry: {
    id: 'confirm-page.country',
    defaultMessage: 'Country',
    description: 'Country label',
  },

  confirmPageAddCompanyDetails: {
    id: 'confirm-page.add-company-details',
    defaultMessage: 'Add company details',
    description: 'Button to expand company form for private person',
  },

  confirmPageRemoveCompanyDetails: {
    id: 'confirm-page.remove-company-details',
    defaultMessage: 'Remove company details',
    description: 'Button to collapse and clear company form',
  },

  bookingProcessError: {
    id: 'bookingProcessError',
    defaultMessage: 'An error occurred during the booking process, please try again later',
    description: 'An error occurred during the booking process, please try again later',
  },

  confirmationBookingPaymentProcessError: {
    id: 'confirmation.bookingPaymentProcessError',
    defaultMessage: 'Due to some reason payment was not successful.',
    description: 'Due to some reason payment was not successful.',
  },

  bookingProcessErrorTitle: {
    id: 'bookingProcessError.title',
    defaultMessage: 'Warning!',
    description: 'Warning!',
  },
  signForgotPass: {
    id: 'login.sign-forgot-pass',
    defaultMessage: 'Forgot password?',
    description: 'Forgot password?',
  },
  loginFailed: {
    id: 'login.sign-failed',
    defaultMessage: 'Incorrect login or password',
    description: 'Incorrect login or password',
  },
  selectTicketStep: {
    id: 'view-progress.select-ticket-step',
    defaultMessage: 'Select Ticket(s)',
    description: 'Select Ticket(s)',
  },
  changeDateLabel: {
    id: 'main-view.changeDate-label',
    defaultMessage: 'Change date',
    description: 'Change date',
  },
  loginAuthGeneralError: {
    id: 'login.auth.general.error',
    defaultMessage: 'Something went wrong! Please try again later or contact our Customer Support',
    description: 'General error for LoginPage',
  },

  changeDirectionLabel: {
    id: 'main-view.changeDirection-label',
    defaultMessage: 'Change direction',
    description: 'Change direction',
  },
  durationOnlyWithHours: {
    id: 'duration-only-with-hours',
    defaultMessage: 'Travel time {hours} hour(s)',
    description: 'Travel time {hours} hour(s)',
  },
  durationOnlyWithMinutes: {
    id: 'duration-only-with-minutes',
    defaultMessage: 'Travel time {minutes} minute(s)',
    description: 'Travel time {minutes} minute(s)',
  },
  durationWithHoursAndMinutes: {
    id: 'duration-with-hours-and-minutes',
    defaultMessage: 'Travel time {hours} hour(s) \n {minutes} minute(s)',
    description: 'Travel time {hours} hour(s) {minutes} minute(s)',
  },
  addReturnRouteLabel: {
    id: 'main-view.add-returnRoute-label',
    defaultMessage: 'Round-trip',
    description: 'Round-trip',
  },

  paymentPendingHeading: {
    id: 'payment.pending.heading',
    defaultMessage: 'Stay tuned!',
    description: 'Stay tuned!',
  },

  paymentPendingReloadButton: {
    id: 'payment.pending.reload.button',
    defaultMessage: 'Refresh',
    description: 'Refresh',
  },
  paymentPendingText: {
    id: 'payment.pending.text',
    defaultMessage:
      'Thank you for your purchase! Currently your payment is still processing. It may take some time for you to get the confirmation of payment. When payment is confirmed you will receive your tickets. Please stay on this page or leave it and wait for confirmation email.',
    description: 'Payment pending text',
  },

  ticketReservationNotFoundError: {
    id: 'ticket.reservation.not.found.error',
    defaultMessage: 'Reservation Not Found! Solution is to start over reservation process.',
    description: 'Reservation Not Found! Solution is to start over reservation process.',
  },
  ticketReservationNotFoundButton: {
    id: 'ticket.reservation.not.found.button',
    defaultMessage: 'Back to main page',
    description: 'Back to main page',
  },
  ticketReservationSailCancelled: {
    id: 'ticket.reservation.sail.cancelled',
    defaultMessage:
      'One or more sails of this reservation has been cancelled. You may pick another sail (change date/time) or cancel it entirely and get 100% refund',
    description: 'Banner text when sail is cancelled by admin',
  },
  ticketReservationBooked: {
    id: 'ticket.reservation.booked',
    defaultMessage:
      'This is your confirmation of the pre-booking. The tickets must be paid for at the ticket office on board',
    description: 'Banner text when ticket is pre-booked',
  },
  noMoreSailsTitle: {
    id: 'no-more-sails-title',
    defaultMessage: 'No more sails available on the selected date!',
    description: 'No more sails available on the selected date!',
  },
  noMoreSailsSubtitle: {
    id: 'no-more-sails-subtitle',
    defaultMessage: 'Choose a new available sail clicking on a specific date in the calendar',
    description: 'Choose a new available sail clicking on a specific date in the calendar',
  },
  availableCapacity: {
    id: 'available-capacity',
    defaultMessage: 'Available capacity',
    description: 'Available capacity',
  },
  clueAdmVehicleAndPassenger: {
    id: 'clue-adm-vehicle-and-passenger',
    defaultMessage:
      'Kindly note that the vehicle ticket does not provide travel for the driver or passengers. Please purchase individual tickets for both the driver and each passenger accompanying the vehicle.',
    description: 'Note',
  },
  outOfStockPart1: {
    id: 'choose-sail.out-of-stock-part1',
    defaultMessage: 'Pre-bookable capacity is sold out.',
    description: 'Pre-bookable capacity is sold out.',
  },
  selectTicketLabel: {
    id: 'select-ticket-label',
    defaultMessage: 'Select Ticket',
    description: 'Select Ticket',
  },
  continueLabel: {
    id: 'continue-label',
    defaultMessage: 'Continue',
    description: 'continue to',
  },
  backButton: {
    id: 'back-button',
    defaultMessage: 'Back',
    description: 'Go back to previous step',
  },
  goBackChangeRoute: {
    id: 'go-back-change-route',
    defaultMessage: 'Go back',
    description: 'Go back to change route',
  },
  goBackChangeRouteSubtitle: {
    id: 'go-back-change-route-subtitle',
    defaultMessage: 'to change route',
    description: 'subtitle of Back button to change route',
  },
  goBackChangeDateTimeSubtitle: {
    id: 'go-back-change-date-time-subtitle',
    defaultMessage: 'to departure selection',
    description: 'subtitle of Back button to departure selection',
  },
  backToTicketSelection: {
    id: 'back-to-ticket-selection',
    defaultMessage: 'to ticket selection',
    description: 'Back button subtitle for checkout page',
  },
  addGroupBtn: {
    id: 'add-to-group-button-text',
    defaultMessage: 'Add to group',
    description: 'Add to group',
  },
  dangerousGoods: {
    id: 'note-about-dangerous-goods',
    defaultMessage: 'This sail is shipping Dangerous Goods',
    description: 'warning danger goods',
  },
  noHeavyTracks: {
    id: 'note-about-no-heavy-tracks',
    defaultMessage: 'Heavy trucks are restricted on this sail',
    description: 'warning no trucks',
  },
  noteAboutCancelled: {
    id: 'note-about-cancelled',
    defaultMessage: 'This sail was cancelled',
    description: 'warning cancelled sail',
  },
  passwordsShouldMatchError: {
    id: 'common-fields.passwords-should-match-error',
    defaultMessage: "Passwords don't match",
    description: "Passwords don't match",
  },
  sessionExpiredHeader: {
    id: 'modal-session-expired-header',
    defaultMessage: 'SESSION EXPIRATION',
    description: 'SESSION EXPIRATION',
  },
  sessionExpired: {
    id: 'modal-session-expired',
    defaultMessage: 'Your session expired, please, start over',
    description: 'Your session expired, please, start over',
  },
  reservationExpiresIn: {
    id: 'reservation.expires-in',
    defaultMessage: 'Booking expires in',
    description: 'Label before the countdown timer in the right column',
  },
  modalOk: {
    id: 'modal-ok',
    defaultMessage: 'OK',
    description: 'OK',
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Loading...',
    description: 'Loading data',
  },
  privateServiceTitle: {
    id: 'private-service-title',
    defaultMessage: 'This service is Private service, not for public.',
    description: 'Private service',
  },
  infoReturnTicket: {
    id: 'info-return-ticket',
    defaultMessage: 'Return Ticket will be only available if booked on same Vessel/Ferry',
    description: 'Message about return ticket',
  },
  nextDayDepartures: {
    id: 'next-day-departures',
    defaultMessage: '* Next-day departures',
    description: 'Next-day departures',
  },
  invalidDate: {
    id: 'invalid-date',
    defaultMessage: 'Invalid date',
    description: 'Invalid date',
  },
  groupTicketsTitle: {
    id: 'group-tickets-title',
    defaultMessage: 'Group Tickets',
    description: 'title - Group Tickets',
  },
  fullChargeTicketsTitle: {
    id: 'full-charge-tickets-title',
    defaultMessage: 'Full charge tickets',
    description: 'title - Full charge tickets',
  },
  freeChargeTicketsTitle: {
    id: 'free-charge-tickets-title',
    defaultMessage: 'Free of charge tickets',
    description: 'title - Free of charge tickets',
  },
  vehiclesTicketsTitle: {
    id: 'vehicles-tickets-title',
    defaultMessage: 'Vehicle ticket',
    description: 'title - Vehicle ticket',
  },
  checkout: {
    id: 'main-inside-destination.checkout',
    defaultMessage: 'Checkout',
    description: 'button - Go to Checkout',
  },
  termCategory: {
    id: 'term-category',
    defaultMessage: 'Category',
    description: 'term - category',
  },
  notesFooterHeading: {
    id: 'notes-footer.heading',
    defaultMessage: 'Passenger checklist',
    description: 'Heading for NotesFooter (Passenger checklist)',
  },
  selectDirectionAndTime: {
    id: 'select-direction-and-time',
    defaultMessage: 'Select direction and time',
    description: 'Header for direction and time selection',
  },
  oneWay: {
    id: 'one-way',
    defaultMessage: 'One way',
    description: 'One way trip option',
  },
  travelDuration: {
    id: 'travel-duration',
    defaultMessage: 'Travel duration',
    description: 'Travel duration label',
  },
  ticketLocalDiscount: {
    id: 'ticket.local-discount',
    defaultMessage: 'Passenger ticket (local resident discount)',
    description: 'button - local resident discount',
  },
  ticketLocalCustomers: {
    id: 'ticket.local-customers',
    defaultMessage: 'Local resident IDs applied',
    description: 'Local resident IDs applied title',
  },
  selectedTicketsCartTitle: {
    id: 'selected-tickets-cart.title',
    defaultMessage: 'Cart',
    description: 'cart title',
  },
  selectedTicketsCartEmpty: {
    id: 'selected-tickets-cart.empty',
    defaultMessage: 'Your cart is empty, please click on ticket to add',
    description: 'cart on select ticket page',
  },
  selectTicketsQty: {
    id: 'select-tickets.qty',
    defaultMessage: 'Quantity',
    description: 'label qty',
  },
  selectTicketsRemoveOne: {
    id: 'select-tickets.remove-one',
    defaultMessage: 'Remove one {title} ticket',
    description: 'accessible name of the minus button on a ticket card',
  },
  selectTicketsAddOne: {
    id: 'select-tickets.add-one',
    defaultMessage: 'Add one {title} ticket',
    description: 'accessible name of the plus button on a ticket card',
  },
  selectTicketsSubtotal: {
    id: 'select-tickets.subtotal',
    defaultMessage: 'Subtotal',
    description: 'ticket qty x price',
  },
  selectTicketsDescription: {
    id: 'select-tickets.description',
    defaultMessage: 'Suitable for everyone without discount eligibility',
    description: 'comment to ticket type',
  },
  selectDiscountTicketsDescription: {
    id: 'select-discount-tickets.description',
    defaultMessage: 'Presenting a document proving eligibility for the discount is mandatory upon boarding',
    description: 'comment to discount ticket type',
  },
  selectTicketsResidentDescription: {
    id: 'select-tickets.resident-description',
    defaultMessage: 'Tickets are sold based on a valid local resident personal code',
    description: 'comment to ticket type for resident',
  },
  selectTicketsPrice: {
    id: 'select-tickets.price',
    defaultMessage: 'Price',
    description: 'label price',
  },
  selectTicketsWarningArea: {
    id: 'select-tickets.warning-area',
    defaultMessage: 'Fill in the necessary details for each item',
    description: 'warning area',
  },
  selectTicketsPassengerLabel: {
    id: 'select-tickets.passenger-label',
    defaultMessage: 'Passenger details',
    description: 'passenger card label',
  },
  selectTicketsPassengerStatus: {
    id: 'select-tickets.passenger-status',
    defaultMessage: 'Required',
    description: 'passenger card status',
  },
  selectTicketsRequiredField: {
    id: 'select-tickets.required-field',
    defaultMessage: 'Required',
    description: 'required field',
  },
  selectTicketsShow: {
    id: 'select-tickets.show',
    defaultMessage: 'show',
    description: 'button show',
  },
  selectTicketsHide: {
    id: 'select-tickets.hide',
    defaultMessage: 'hide',
    description: 'button hide',
  },
  paymentMethodsTitle: {
    id: 'payment-methods.title',
    defaultMessage: 'Choose payment method',
    description: 'Payment methods section title',
  },
  payButtonTitle: {
    id: 'pay-button.title',
    defaultMessage: 'PAY',
    description: 'Pay button title',
  },
  payButtonSubtitle: {
    id: 'pay-button.subtitle',
    defaultMessage: 'for purchase',
    description: 'Pay button subtitle',
  },
  confirmFreeButtonTitle: {
    id: 'confirm-free-button.title',
    defaultMessage: 'CONTINUE',
    description: 'Confirm button title for free tickets (no payment needed)',
  },
  confirmFreeButtonSubtitle: {
    id: 'confirm-free-button.subtitle',
    defaultMessage: 'to checkout',
    description: 'Confirm button subtitle for free tickets',
  },
  ticketsNextSubtitle: {
    id: 'select-tickets-next.subtitle',
    defaultMessage: 'to checkout',
    description: 'Next button subtitle on select tickets page',
  },
  confirmPageReservationStatus: {
    id: 'confirm-page.reservation-status',
    defaultMessage: 'The status of the reservation is: {status}. It might be already paid.',
    description: 'Reservation status message',
  },
  signFieldPassword: {
    id: 'signFieldPassword',
    defaultMessage: 'Password',
    description: 'Password field label',
  },
  signFieldRepeatPassword: {
    id: 'signFieldRepeatPassword',
    defaultMessage: 'Repeat password',
    description: 'Repeat password field label',
  },
  signFieldRepeatPasswordPlaceholder: {
    id: 'signFieldRepeatPasswordPlaceholder',
    defaultMessage: 'Repeat password',
    description: 'Repeat password placeholder',
  },
  signupCreateAccount: {
    id: 'signupCreateAccount',
    defaultMessage: 'Create account',
    description: 'Create account button text',
  },
  signupAlreadyHaveAccount: {
    id: 'signupAlreadyHaveAccount',
    defaultMessage: 'Do you already have an account?',
    description: 'Already have account text',
  },
  signInLink: {
    id: 'signInLink',
    defaultMessage: 'Log in.',
    description: 'Sign in link text',
  },
  signupAccountBenefits: {
    id: 'signupAccountBenefits',
    defaultMessage:
      'A user account allows you to conveniently view and manage your tickets and bookings in one place. You get a quick overview of active purchases and past purchase history - simply and securely.',
    description: 'Account benefits description for signup',
  },
  signupBenefit1: {
    id: 'signupBenefit1',
    defaultMessage: 'view and manage your active tickets and bookings',
    description: 'Account benefit 1 for signup',
  },
  signupBenefit2: {
    id: 'signupBenefit2',
    defaultMessage: 'see past purchases and order history',
    description: 'Account benefit 2 for signup',
  },
  signupBenefit3: {
    id: 'signupBenefit3',
    defaultMessage: 'save data for faster future purchases',
    description: 'Account benefit 3 for signup',
  },
  signupBenefit4: {
    id: 'signupBenefit4',
    defaultMessage: 'download receipts and purchase documents',
    description: 'Account benefit 4 for signup',
  },
  signupBenefit5: {
    id: 'signupBenefit5',
    defaultMessage: 'manage a company account and make purchases as a business client',
    description: 'Account benefit 5 for signup',
  },
  confirmationContactFormRequiredError: {
    id: 'confirmationContactFormRequiredError',
    defaultMessage: 'Required field',
    description: 'Required field error for contact form',
  },
  signupTermsText: {
    id: 'signupTermsText',
    defaultMessage: 'I have read and agree to',
    description: 'Terms and conditions text',
  },
  signupTermsLink: {
    id: 'signupTermsLink',
    defaultMessage: 'terms of use',
    description: 'Terms and conditions link text',
  },
  signupTermsRequired: {
    id: 'signupTermsRequired',
    defaultMessage: 'You must accept the terms and conditions',
    description: 'Error message when terms are not accepted during signup',
  },
  passwordsDoNotMatch: {
    id: 'common-fields.passwords-should-match-error',
    defaultMessage: "Passwords don't match",
    description: "Error message when passwords don't match (alias for passwordsShouldMatchError)",
  },
  loginRememberMe: {
    id: 'loginRememberMe',
    defaultMessage: 'Remember me',
    description: 'Remember me checkbox label for login form',
  },
  loginForgotPassword: {
    id: 'loginForgotPassword',
    defaultMessage: 'Forgot password?',
    description: 'Forgot password link text for login form',
  },
  loginCreateAccountTitle: {
    id: 'loginCreateAccountTitle',
    defaultMessage: 'Create an account to manage your tickets and bookings',
    description: 'Title for create account section on login page',
  },
  loginAccountBenefits: {
    id: 'loginAccountBenefits',
    defaultMessage:
      'A user account allows you to conveniently view and manage your tickets and bookings in one place. You get a quick overview of active purchases and past purchase history - simply and securely.',
    description: 'Account benefits description for login page',
  },
  loginBenefit1: {
    id: 'loginBenefit1',
    defaultMessage: 'view and manage your active tickets and bookings',
    description: 'Account benefit 1 for login page',
  },
  loginBenefit2: {
    id: 'loginBenefit2',
    defaultMessage: 'see past purchases and order history',
    description: 'Account benefit 2 for login page',
  },
  loginBenefit3: {
    id: 'loginBenefit3',
    defaultMessage: 'save data for faster future purchases',
    description: 'Account benefit 3 for login page',
  },
  loginBenefit4: {
    id: 'loginBenefit4',
    defaultMessage: 'download receipts and purchase documents',
    description: 'Account benefit 4 for login page',
  },
  loginBenefit5: {
    id: 'loginBenefit5',
    defaultMessage: 'manage a company account and make purchases as a business client',
    description: 'Account benefit 5 for login page',
  },
  loginCreateAccountButton: {
    id: 'loginCreateAccountButton',
    defaultMessage: 'Create account',
    description: 'Create account button text for login page',
  },
  profileSettingsTab: {
    id: 'profileSettingsTab',
    defaultMessage: 'YOUR SETTINGS',
    description: 'Profile settings tab label',
  },
  profileTicketsTab: {
    id: 'profileTicketsTab',
    defaultMessage: 'TICKETS',
    description: 'Profile tickets tab label',
  },
  profileUsersTab: {
    id: 'profileUsersTab',
    defaultMessage: 'USERS',
    description: 'Profile users tab label',
  },
  profileUsersContentPlaceholder: {
    id: 'profile-users-content-placeholder',
    defaultMessage: 'Users content will be here',
    description: 'Placeholder text for users tab content',
  },
  privateCustomer: {
    id: 'privateCustomer',
    defaultMessage: 'Private customer',
    description: 'Private customer label',
  },
  legalCustomer: {
    id: 'legalCustomer',
    defaultMessage: 'Legal customer',
    description: 'Legal customer label',
  },
  legalCustomerRepresentative: {
    id: 'legalCustomerRepresentative',
    defaultMessage: "Legal customer's representative",
    description: 'Legal customer representative label',
  },
  creditLimit: {
    id: 'creditLimit',
    defaultMessage: 'Credit limit',
    description: 'Credit limit label',
  },
  month: {
    id: 'month',
    defaultMessage: 'month',
    description: 'Month label',
  },
  used: {
    id: 'used',
    defaultMessage: 'Used',
    description: 'Used label',
  },
  remaining: {
    id: 'remaining',
    defaultMessage: 'Remaining',
    description: 'Remaining label',
  },
  daysUntilRenew: {
    id: 'daysUntilRenew',
    defaultMessage: 'Days until renew',
    description: 'Days until renew label',
  },
  userCredentials: {
    id: 'userCredentials',
    defaultMessage: 'User credentials',
    description: 'User credentials section title',
  },
  loginEmail: {
    id: 'loginEmail',
    defaultMessage: 'Login / Email',
    description: 'Login / Email label',
  },
  password: {
    id: 'password',
    defaultMessage: 'Password',
    description: 'Password label',
  },
  clickHereToChangePassword: {
    id: 'clickHereToChangePassword',
    defaultMessage: 'Click here to change password',
    description: 'Click here to change password link',
  },
  unused: {
    id: 'unused',
    defaultMessage: 'Unused',
    description: 'Unused credit limit label',
  },
  privateCustomerDescription: {
    id: 'privateCustomerDescription',
    defaultMessage:
      'Private customer (this information is used for invoicing and contacting to you, like sending you tickets)',
    description: 'Private customer description text',
  },
  pinLoginNotification: {
    id: 'pinLoginNotification',
    defaultMessage: 'Login by your Personal Identification Number (PIN)',
    description: 'Notifies that user registration method is PIN',
  },
  legalCustomerDescription: {
    id: 'legalCustomerDescription',
    defaultMessage:
      "Legal customer's representative (this information is used for invoicing and contacting to you, like sending you tickets)",
    description: 'Legal customer description text',
  },
  regNr: {
    id: 'regNr',
    defaultMessage: 'Reg nr.',
    description: 'Registration number short label',
  },
  addCompany: {
    id: 'addCompany',
    defaultMessage: 'ADD COMPANY',
    description: 'Add company button text',
  },
  remove: {
    id: 'remove',
    defaultMessage: 'REMOVE',
    description: 'Remove button text',
  },
  editReservationTab: {
    id: 'edit-reservation.tab',
    defaultMessage: 'Change date and time',
    description: 'Change date and time tab label',
  },
  editReservationTitle: {
    id: 'edit-reservation.title',
    defaultMessage: 'Edit reservation no.',
    description: 'Edit reservation page title',
  },
  travelDataTab: {
    id: 'edit-reservation.travel-data-tab',
    defaultMessage: 'Change tickets',
    description: 'Change tickets tab label',
  },
  additionalServicesTab: {
    id: 'edit-reservation.additional-services-tab',
    defaultMessage: 'Change customer data',
    description: 'Change customer data tab label',
  },
  selectTicketsFirstname: {
    id: 'select-tickets.firstname',
    defaultMessage: 'First Name',
    description: 'First Name',
  },
  selectTicketsLastname: {
    id: 'select-tickets.lastname',
    defaultMessage: 'Last Name',
    description: 'Last Name',
  },
  selectTicketsExtraInfo: {
    id: 'select-tickets.extra-info',
    defaultMessage: 'Additional info',
    description: 'Additional info',
  },
  selectTicketsCitizenship: {
    id: 'select-tickets.citizenship',
    defaultMessage: 'Citizenship',
    description: 'label citizenship',
  },
  citizenshipPlaceholder: {
    id: 'select-tickets.citizenship-placeholder',
    defaultMessage: 'Citizenship',
    description: 'placeholder citizenship',
  },
  selectTicketsGender: {
    id: 'select-tickets.gender',
    defaultMessage: 'Gender',
    description: 'label gender',
  },
  selectTicketsGenderM: {
    id: 'select-tickets.gender-male',
    defaultMessage: 'M',
    description: 'gender male',
  },
  selectTicketsGenderF: {
    id: 'select-tickets.gender-female',
    defaultMessage: 'F',
    description: 'gender female',
  },
  selectTicketsBirthdate: {
    id: 'select-tickets.birthdate',
    defaultMessage: 'Date of birth',
    description: 'Date of birth',
  },
  selectTicketsPersonalId: {
    id: 'select-tickets.personal-id',
    defaultMessage: 'Personal code',
    description: 'personal code',
  },
  selectTicketsNoPersonalId: {
    id: 'select-tickets.no-personal-id',
    defaultMessage: 'Unknown',
    description: 'shown when passenger personal ID is not provided',
  },
  selectTicketsEnterPersonalId: {
    id: 'select-tickets.enter-personal-id',
    defaultMessage: 'Enter personal code',
    description: 'label on button',
  },
  selectTicketsResidentId: {
    id: 'select-tickets.resident-id',
    defaultMessage: 'Resident personal code',
    description: 'placeholder',
  },
  selectTicketsResidentTicket: {
    id: 'select-tickets.resident-ticket',
    defaultMessage: 'Discount ticket for a permanent resident',
    description: 'title on resident card',
  },
  buttonProcessing: {
    id: 'button.processing',
    defaultMessage: 'Processing...',
    description: 'subtitle of a button while its request is running',
  },
  buttonCancel: {
    id: 'button.cancel',
    defaultMessage: 'Cancel',
    description: 'button cancel',
  },
  buttonCancelSubtitle: {
    id: 'button.refund.subtitle',
    defaultMessage: 'ticket refund',
    description: 'button cancel refund subtitle',
  },
  buttonRefundContinue: {
    id: 'button.refund.continue',
    defaultMessage: 'Refund',
    description: 'button continue refund',
  },
  buttonRefundContinueSubtitle: {
    id: 'button.refund.continue.subtitle',
    defaultMessage: 'selected ticket',
    description: 'button continue refund subtitle',
  },
  buttonSave: {
    id: 'button.save',
    defaultMessage: 'Save',
    description: 'button save',
  },
  buttonDeleteTicket: {
    id: 'button.delete-ticket',
    defaultMessage: 'Delete ticket',
    description: 'button Delete ticket',
  },
  buttonCheckId: {
    id: 'button.check-id',
    defaultMessage: 'Check',
    description: 'button check id',
  },
  authSignupUserExists: {
    id: 'auth.signup-user-exists',
    defaultMessage: 'An account with this email already exists',
    description: 'Error when user tries to register with existing email',
  },
  authActivationAlreadyActivated: {
    id: 'auth.activation-already-activated',
    defaultMessage: 'This account has already been activated. You can log in.',
    description: 'Error when user tries to activate an already activated account',
  },
  authSignupInvalidEmail: {
    id: 'auth.signup-invalid-email',
    defaultMessage: 'Invalid email format',
    description: 'Error when user enters invalid email during signup',
  },
  authSignupWeakPassword: {
    id: 'auth.signup-weak-password',
    defaultMessage: 'Password does not meet the requirements',
    description: 'Error when password is too weak during signup',
  },
  authActivating: {
    id: 'auth.activating',
    defaultMessage: 'Activating your account...',
    description: 'Message shown while account is being activated',
  },
  authActivationSuccess: {
    id: 'auth.activation-success',
    defaultMessage: 'Your account has been activated! You can now log in.',
    description: 'Message shown after successful account activation',
  },
  authLoginEmailTitle: {
    id: 'auth.login-email-title',
    defaultMessage: 'Log in with email address',
    description: 'Login form title',
  },
  authRememberMe: {
    id: 'auth.remember-me',
    defaultMessage: 'Remember me on this device',
    description: 'Remember me checkbox label on login form',
  },
  authRegistrationBenefitsHeading: {
    id: 'auth.registration-benefits-heading',
    defaultMessage: 'Create an account to manage your tickets and bookings',
    description: 'Heading for registration benefits section on login page',
  },
  authSending: {
    id: 'auth.sending',
    defaultMessage: 'Sending...',
    description: 'Button text while auth request is in progress',
  },
  authResetPasswordSuccess: {
    id: 'auth.reset-password-success',
    defaultMessage: 'Your password has been successfully reset. You can now log in.',
    description: 'Banner message shown after successful password reset request',
  },
  profileErrorSaveUserFailed: {
    id: 'profile-error-save-user-failed',
    defaultMessage: 'Failed to save user data',
    description: 'Error message when saving user data fails',
  },
  profileErrorSaveCompanyFailed: {
    id: 'profile-error-save-company-failed',
    defaultMessage: 'Failed to save company data',
    description: 'Error message when saving company data fails',
  },
  profileErrorAddCompanyFailed: {
    id: 'profile-error-add-company-failed',
    defaultMessage: 'Failed to add company',
    description: 'Error message when adding company fails',
  },
  profileErrorRemoveCompanyFailed: {
    id: 'profile-error-remove-company-failed',
    defaultMessage: 'Failed to remove company',
    description: 'Error message when removing company fails',
  },
  profileErrorMissingCompanyId: {
    id: 'profile-error-missing-company-id',
    defaultMessage: 'Cannot remove company: missing company ID',
    description: 'Error message when company ID is missing for removal',
  },
  profileLoading: {
    id: 'profile-loading',
    defaultMessage: 'Loading...',
    description: 'Loading state message',
  },
  profileErrorLoading: {
    id: 'profile-error-loading',
    defaultMessage: 'Error loading data. Please try again later.',
    description: 'Error message when data loading fails',
  },
  profilePleaseLogin: {
    id: 'profile-please-login',
    defaultMessage: 'Please log in to view your profile data.',
    description: 'Message shown when user is not authenticated',
  },
  profileErrorSaving: {
    id: 'profile-error-saving',
    defaultMessage: 'Error saving data',
    description: 'Error message title when saving fails',
  },
  profileSaving: {
    id: 'profile-saving',
    defaultMessage: 'Saving changes...',
    description: 'Message shown while saving changes',
  },
  profileDismiss: {
    id: 'profile-dismiss',
    defaultMessage: 'Dismiss',
    description: 'Button text to dismiss error message',
  },
  profileContactFormCodePlaceholder: {
    id: 'profile.contact-form.code-placeholder',
    defaultMessage: '+372',
    description: 'Code Placeholder',
  },
  profileContactFormPhonePlaceholder: {
    id: 'profile.contact-form.phone-placeholder',
    defaultMessage: '123456789',
    description: 'Phone Placeholder',
  },
  ticketsFilterTicketNr: {
    id: 'tickets-filter-ticket-nr',
    defaultMessage: 'Ticket nr.',
    description: 'Label for ticket number filter',
  },
  ticketsFilterDate: {
    id: 'tickets-filter-date',
    defaultMessage: 'Date',
    description: 'Label for date filter',
  },
  ticketsFilterDateStart: {
    id: 'tickets-filter-date-start',
    defaultMessage: 'Start',
    description: 'Label for start date filter',
  },
  ticketsFilterDateEnd: {
    id: 'tickets-filter-date-end',
    defaultMessage: 'End',
    description: 'Label for end date filter',
  },
  ticketsFilterDirection: {
    id: 'tickets-filter-direction',
    defaultMessage: 'Direction',
    description: 'Label for direction filter',
  },
  ticketsFilterDirectionPlaceholder: {
    id: 'tickets-filter-direction-placeholder',
    defaultMessage: 'All',
    description: 'Default option for direction filter dropdown (all directions)',
  },
  ticketsFilterPayer: {
    id: 'tickets-filter-payer',
    defaultMessage: 'Payer',
    description: 'Label for payer filter',
  },
  ticketsFilterPaymentMethod: {
    id: 'tickets-filter-payment-method',
    defaultMessage: 'Payment method',
    description: 'Label for payment method filter',
  },
  ticketsFilterSearchPlaceholder: {
    id: 'tickets-filter-search-placeholder',
    defaultMessage: 'Search...',
    description: 'Placeholder text for search inputs',
  },
  ticketsFilterReset: {
    id: 'tickets-filter-reset',
    defaultMessage: 'Reset',
    description: 'Button text to reset all filters',
  },
  ticketsFilterPaymentAll: {
    id: 'tickets-filter-payment-all',
    defaultMessage: 'All',
    description: 'Option for all payment methods',
  },
  ticketsFilterPaymentCash: {
    id: 'tickets-filter-payment-cash',
    defaultMessage: 'Cash',
    description: 'Payment method option: Cash',
  },
  ticketsFilterPaymentCard: {
    id: 'tickets-filter-payment-card',
    defaultMessage: 'Card',
    description: 'Payment method option: Card',
  },
  ticketsFilterPaymentCredit: {
    id: 'tickets-filter-payment-credit',
    defaultMessage: 'Credit',
    description: 'Payment method option: Credit',
  },
  ticketsFilterShowCancelled: {
    id: 'tickets-filter-show-cancelled',
    defaultMessage: 'Include cancelled e-tickets',
    description: 'Checkbox label to include cancelled reservations in results',
  },
  ticketsFilterHidePrevious: {
    id: 'tickets-filter-hide-previous',
    defaultMessage: 'Hide previous purchases',
    description: 'Button to hide past/expired reservations',
  },
  ticketsFilterViewPrevious: {
    id: 'tickets-filter-view-previous',
    defaultMessage: 'View all previous purchases',
    description: 'Button to show past/expired reservations',
  },
  ticketsNotFound: {
    id: 'tickets-not-found',
    defaultMessage: 'Tickets not found',
    description: 'Message shown when no tickets match the filters',
  },
  ticketsTicketNumber: {
    id: 'tickets-ticket-number',
    defaultMessage: 'Ticket #',
    description: 'Label prefix for ticket number display',
  },
  ticketActionView: {
    id: 'ticket-action-view',
    defaultMessage: 'View',
    description: 'Tooltip for view ticket button',
  },
  ticketActionDownload: {
    id: 'ticket-action-download',
    defaultMessage: 'Download',
    description: 'Tooltip for download ticket button',
  },
  ticketActionEdit: {
    id: 'ticket-action-edit',
    defaultMessage: 'Edit',
    description: 'Tooltip for edit ticket button',
  },
  ticketActionRemove: {
    id: 'ticket-action-remove',
    defaultMessage: 'Cancel',
    description: 'Tooltip for cancel/remove ticket button',
  },
  recoveryDescription: {
    id: 'recovery.description',
    defaultMessage: 'Enter your registered email address and we will send you a link to reset your password.',
    description: 'Description text on forgot password form',
  },
  recoveryEmailSentMessage: {
    id: 'recovery.email-sent-message',
    defaultMessage: 'Check your email and follow instructions.',
    description: 'Message shown after recovery email is sent',
  },
  recoveryNewPasswordTitle: {
    id: 'recovery.new-password-title',
    defaultMessage: 'Enter new password',
    description: 'Title on reset password form',
  },
  recoveryConfirmPasswordLabel: {
    id: 'recovery.confirm-password-label',
    defaultMessage: 'Confirm password',
    description: 'Label for confirm password field',
  },
  recoveryEmailLabel: {
    id: 'recovery.email-label',
    defaultMessage: 'E-mail',
    description: 'Label for email field on recovery form',
  },
  recoveryPasswordLabel: {
    id: 'recovery.password-label',
    defaultMessage: 'Password',
    description: 'Label for password field on recovery form',
  },
  recoverySaveButton: {
    id: 'recovery.save-button',
    defaultMessage: 'Save',
    description: 'Save button on reset password form',
  },
  recoveryForgotPasswordQuestion: {
    id: 'recovery.forgot-password-question',
    defaultMessage: 'Forgot password?',
    description: 'Title inside the recovery card',
  },
  recoveryValidatingToken: {
    id: 'recovery.validating-token',
    defaultMessage: 'Validating your link...',
    description: 'Loading message while validating password reset token',
  },
  recoveryTokenInvalid: {
    id: 'recovery.token-invalid',
    defaultMessage: 'This link has expired or is invalid. Please request a new password reset link.',
    description: 'Error when password reset token is invalid or expired',
  },
  POPULATION_REGISTER_BAD_REQUEST: {
    id: 'error.population-register-bad-request',
    defaultMessage: 'The personal code does not meet the requirements',
    description: 'Error from the register if ID is invalid',
  },
  NO_DISCOUNT_ON_ROUTE: {
    id: 'error.no-discount-on-route',
    defaultMessage: 'This person has no discount on route',
    description: 'Error from the register if ID is invalid',
  },
  INVALID_PERSONAL_IDENTIFICATION_NUMBER: {
    id: 'error.invalid-personal-identification-number',
    defaultMessage: 'The personal identification code is not valid. Please check it and try again.',
    description: 'Error from reservation if the personal code has a wrong check digit or length',
  },
  authIdKaartLogin: {
    id: 'auth.id-kaart-login',
    defaultMessage: 'Sign in with ID-card',
    description: 'ID-kaart login button text',
  },
  authIdKaartSignup: {
    id: 'auth.id-kaart-signup',
    defaultMessage: 'Register with ID-card',
    description: 'ID-kaart signup button text',
  },
  authIdKaartLoading: {
    id: 'auth.id-kaart-loading',
    defaultMessage: 'Reading card...',
    description: 'ID-kaart loading state button text',
  },
  authIdKaartTitle: {
    id: 'auth.id-kaart-title',
    defaultMessage: 'Sign in with ID-card',
    description: 'ID-kaart auth section title',
  },
  authIdKaartDescription: {
    id: 'auth.id-kaart-description',
    defaultMessage: 'Insert your ID-card into the card reader and press "Sign in".',
    description: 'ID-kaart auth section description',
  },
  authIdKaartRememberMe: {
    id: 'auth.id-kaart-remember-me',
    defaultMessage: 'Keep me logged in for 7 days',
    description: 'ID-kaart remember me checkbox label',
  },
  authErrorWebeidNotAvailable: {
    id: 'auth.error-webeid-not-available',
    defaultMessage: 'Web eID browser extension is not installed. Please install it from web-eid.eu',
    description: 'Error when Web eID browser extension is not installed',
  },
  authErrorWebeidNativeNotAvailable: {
    id: 'auth.error-webeid-native-not-available',
    defaultMessage: 'Web eID application is not installed. Please install it from web-eid.eu',
    description: 'Error when Web eID native application is not installed',
  },
  authErrorWebeidTimeout: {
    id: 'auth.error-webeid-timeout',
    defaultMessage: 'Authentication timed out. Please try again.',
    description: 'Error when Web eID authentication times out',
  },
  authErrorCertificateExpired: {
    id: 'auth.error-certificate-expired',
    defaultMessage: 'Your ID-card certificate has expired.',
    description: 'Error when ID-card certificate is expired',
  },
  authErrorHttpsRequired: {
    id: 'auth.error-https-required',
    defaultMessage: 'Secure connection (HTTPS) required for ID-card authentication.',
    description: 'Error when page is not served over HTTPS',
  },
  authErrorCardReaderNotFound: {
    id: 'auth.error-card-reader-not-found',
    defaultMessage: 'Card reader error. Please check your card reader and try again.',
    description: 'Error when card reader is not found or has an issue',
  },
  authErrorWebeidVersionMismatch: {
    id: 'auth.error-webeid-version-mismatch',
    defaultMessage: 'Please update Web eID browser extension and application.',
    description: 'Error when Web eID version is incompatible',
  },
  authErrorVerifyFailed: {
    id: 'auth.error-verify-failed',
    defaultMessage: 'ID-card verification failed. Please try again.',
    description: 'Error when server-side ID-card verification fails',
  },
  authErrorChallengeExpired: {
    id: 'auth.error-challenge-expired',
    defaultMessage: 'Authentication session expired. Please try again.',
    description: 'Error when challenge token has expired',
  },
  commonNotificationError: {
    id: 'common-notification.error',
    defaultMessage: 'Error!',
    description: 'common error',
  },
  commonNotificationErrorDesc: {
    id: 'common-notification.error-desc',
    defaultMessage: 'Something went wrong! Please try again later or contact our Customer Support.',
    description: 'description of common error',
  },
  errorRedCodePrefix: {
    id: 'error.red.code.prefix',
    defaultMessage: 'Error code:',
    description: 'error code',
  },
  selectDayPlaceholder: {
    id: 'select-tickets.day-placeholder',
    defaultMessage: 'day',
  },
  selectMonthPlaceholder: {
    id: 'select-tickets.month-placeholder',
    defaultMessage: 'month',
  },
  selectYearPlaceholder: {
    id: 'select-tickets.year-placeholder',
    defaultMessage: 'year',
  },
  discountAlreadyUsedInReservation: {
    id: 'error.discount-already-used-in-reservation',
    defaultMessage: "The local traveler's discount is already applied (Error code: dRiAp)",
  },
  discountAlreadyUsedOnSail: {
    id: 'error.discount-already-used-on-sail',
    defaultMessage: 'Your ticket already registered on the ship (Error code: cWtTI)',
  },
  failedToAllocatePaxInventory: {
    id: 'error.failed-to-allocate-pax-inventory',
    defaultMessage: 'No passenger tickets available (Error code: vvYgf)',
  },
  authSmartIdLogin: {
    id: 'auth.smart-id-login',
    defaultMessage: 'Sign in with Smart-ID',
    description: 'Smart-ID login button text',
  },
  authSmartIdSignup: {
    id: 'auth.smart-id-signup',
    defaultMessage: 'Register with Smart-ID',
    description: 'Smart-ID signup button text',
  },
  authSmartIdTitle: {
    id: 'auth.smart-id-title',
    defaultMessage: 'Sign in with Smart-ID',
    description: 'Smart-ID auth section title',
  },
  authSmartIdDescription: {
    id: 'auth.smart-id-description',
    defaultMessage: 'Enter your personal identification number to sign in.',
    description: 'Smart-ID auth section description',
  },
  authSmartIdPersonalIdLabel: {
    id: 'auth.smart-id-personal-id-label',
    defaultMessage: 'Personal identification number',
    description: 'Smart-ID personal ID input label',
  },
  authSmartIdPersonalIdPlaceholder: {
    id: 'auth.smart-id-personal-id-placeholder',
    defaultMessage: '38001085718',
    description: 'Smart-ID personal ID input placeholder',
  },
  authSmartIdCountryLabel: {
    id: 'auth.smart-id-country-label',
    defaultMessage: 'Country',
    description: 'Smart-ID country select label',
  },
  authSmartIdWaiting: {
    id: 'auth.smart-id-waiting',
    defaultMessage: 'Please confirm on your Smart-ID app',
    description: 'Smart-ID waiting for confirmation message',
  },
  authSmartIdVerificationCode: {
    id: 'auth.smart-id-verification-code',
    defaultMessage: 'Verification code:',
    description: 'Smart-ID verification code label',
  },
  authSmartIdPreparing: {
    id: 'auth.smart-id-preparing',
    defaultMessage: 'Sending request...',
    description: 'Smart-ID preparing state',
  },
  authSmartIdCountryEE: {
    id: 'auth.smart-id-country-ee',
    defaultMessage: 'Estonia (EE)',
    description: 'Smart-ID country option for Estonia',
  },
  authSmartIdCountryLV: {
    id: 'auth.smart-id-country-lv',
    defaultMessage: 'Latvia (LV)',
    description: 'Smart-ID country option for Latvia',
  },
  authSmartIdCountryLT: {
    id: 'auth.smart-id-country-lt',
    defaultMessage: 'Lithuania (LT)',
    description: 'Smart-ID country option for Lithuania',
  },
  authSmartIdPrepareError: {
    id: 'auth.smart-id-prepare-error',
    defaultMessage: 'Smart-ID authentication failed. Please try again.',
    description: 'Smart-ID generic prepare error',
  },
  authSmartIdPerformError: {
    id: 'auth.smart-id-perform-error',
    defaultMessage: 'Smart-ID confirmation failed. Please try again.',
    description: 'Smart-ID generic confirmation error',
  },
  authSmartIdInvalidRequest: {
    id: 'auth.smart-id-invalid-request',
    defaultMessage: 'Invalid request payload',
    description: 'Smart-ID invalid request error',
  },
  authSmartIdMissingSessionId: {
    id: 'auth.smart-id-missing-session-id',
    defaultMessage: 'Session ID is required',
    description: 'Smart-ID missing session id error',
  },
  authSmartIdUserRefused: {
    id: 'auth.smart-id-user-refused',
    defaultMessage: 'Smart-ID request was cancelled by the user.',
    description: 'Smart-ID user refused confirmation',
  },
  authSmartIdTimeout: {
    id: 'auth.smart-id-timeout',
    defaultMessage: 'Smart-ID confirmation timed out. Please try again.',
    description: 'Smart-ID confirmation timeout',
  },
  authSmartIdDocumentUnusable: {
    id: 'auth.smart-id-document-unusable',
    defaultMessage: 'Smart-ID document is unusable. Please contact support or try another method.',
    description: 'Smart-ID document unusable error',
  },
  authSmartIdWrongVc: {
    id: 'auth.smart-id-wrong-vc',
    defaultMessage: 'Smart-ID verification code did not match. Please try again.',
    description: 'Smart-ID wrong verification code',
  },
  authMobileIdLogin: {
    id: 'auth.mobile-id-login',
    defaultMessage: 'Sign in with Mobile-ID',
    description: 'Mobile-ID login button text',
  },
  authMobileIdSignup: {
    id: 'auth.mobile-id-signup',
    defaultMessage: 'Register with Mobile-ID',
    description: 'Mobile-ID signup button text',
  },
  authMobileIdTitle: {
    id: 'auth.mobile-id-title',
    defaultMessage: 'Sign in with Mobile-ID',
    description: 'Mobile-ID auth section title',
  },
  authMobileIdDescription: {
    id: 'auth.mobile-id-description',
    defaultMessage: 'Enter your personal identification number and phone number to sign in.',
    description: 'Mobile-ID auth section description',
  },
  authMobileIdPersonalIdLabel: {
    id: 'auth.mobile-id-personal-id-label',
    defaultMessage: 'Personal identification number',
    description: 'Mobile-ID personal ID input label',
  },
  authMobileIdPersonalIdPlaceholder: {
    id: 'auth.mobile-id-personal-id-placeholder',
    defaultMessage: '38001085718',
    description: 'Mobile-ID personal ID input placeholder',
  },
  authMobileIdPhoneLabel: {
    id: 'auth.mobile-id-phone-label',
    defaultMessage: 'Phone number',
    description: 'Mobile-ID phone input label',
  },
  authMobileIdPhonePlaceholder: {
    id: 'auth.mobile-id-phone-placeholder',
    defaultMessage: '+37200000766',
    description: 'Mobile-ID phone input placeholder',
  },
  authMobileIdWaiting: {
    id: 'auth.mobile-id-waiting',
    defaultMessage: 'Confirm the request on your phone with Mobile-ID PIN codes.',
    description: 'Mobile-ID waiting for confirmation message',
  },
  authMobileIdVerificationCode: {
    id: 'auth.mobile-id-verification-code',
    defaultMessage: 'Verification code:',
    description: 'Mobile-ID verification code label',
  },
  authMobileIdCodeHint: {
    id: 'auth.mobile-id-code-hint',
    defaultMessage: 'Make sure the code on your phone matches this code before entering your PIN.',
    description: 'Mobile-ID verification code hint',
  },
  authMobileIdPreparing: {
    id: 'auth.mobile-id-preparing',
    defaultMessage: 'Sending request...',
    description: 'Mobile-ID preparing state',
  },
  authMobileIdProcessing: {
    id: 'auth.mobile-id-processing',
    defaultMessage: 'Waiting for confirmation...',
    description: 'Mobile-ID processing state',
  },
  authMobileIdPrepareError: {
    id: 'auth.mobile-id-prepare-error',
    defaultMessage: 'Mobile-ID authentication failed. Please try again.',
    description: 'Mobile-ID generic prepare error',
  },
  authMobileIdProcessError: {
    id: 'auth.mobile-id-process-error',
    defaultMessage: 'Mobile-ID confirmation failed. Please try again.',
    description: 'Mobile-ID generic confirmation error',
  },
  authMobileIdInvalidRequest: {
    id: 'auth.mobile-id-invalid-request',
    defaultMessage: 'Invalid request payload',
    description: 'Mobile-ID invalid request error',
  },
  authMobileIdCancelledByUser: {
    id: 'auth.mobile-id-cancelled-by-user',
    defaultMessage: 'Mobile-ID request was cancelled by the user.',
    description: 'Mobile-ID cancelled by user error',
  },
  authMobileIdTimeout: {
    id: 'auth.mobile-id-timeout',
    defaultMessage: 'Mobile-ID confirmation timed out. Please try again.',
    description: 'Mobile-ID timeout error',
  },
  authMobileIdInvalidPersonalId: {
    id: 'auth.mobile-id-invalid-personal-id',
    defaultMessage: 'Invalid personal identification number.',
    description: 'Mobile-ID invalid personal ID error',
  },
  authMobileIdInvalidPhoneNumber: {
    id: 'auth.mobile-id-invalid-phone-number',
    defaultMessage: 'Invalid phone number. Use an Estonian number in +372 format.',
    description: 'Mobile-ID invalid phone number error',
  },
  authMobileIdNotMobileIdClient: {
    id: 'auth.mobile-id-not-mobile-id-client',
    defaultMessage: 'This phone number is not configured for Mobile-ID.',
    description: 'Mobile-ID not a Mobile-ID client error',
  },
  ticketImpossibleEditCancel: {
    id: 'ticket.impossible-edit-cancel',
    defaultMessage:
      'It is not possible to change or cancel e-tickets because this possibility is no longer valid ({days} days passed)',
    description: 'impossible edit and cancel',
  },
  bookedTicketReservationSailCancelled: {
    id: 'booked-ticket.reservation.sail.cancelled',
    defaultMessage:
      'One or more sails of this reservation has been cancelled. For changing the departure date or cancelling the tickets, please contact our Customer Support: {phone}',
    description: 'Banner text when booked sail is cancelled by admin',
  },
  editSessionLabel: {
    id: 'edit-reservation.session-label',
    defaultMessage: 'Edit Session:',
    description: 'Edit reservation session timer label',
  },
  editSessionExpired: {
    id: 'edit-reservation.session-expired',
    defaultMessage: 'Session expired',
    description: 'Edit reservation session expired text',
  },
  editSessionRemaining: {
    id: 'edit-reservation.session-remaining',
    defaultMessage: '{time} remaining',
    description: 'Edit reservation session time remaining',
  },
  editSessionExpiringSoon: {
    id: 'edit-reservation.session-expiring-soon',
    defaultMessage: 'Save your changes soon or the session will expire',
    description: 'Edit reservation session expiring soon warning',
  },
  editSessionProlongTitle: {
    id: 'edit-reservation.session-prolong-title',
    defaultMessage: 'Session expiring soon',
    description: 'Edit reservation session prolong modal title',
  },
  editSessionProlongBody: {
    id: 'edit-reservation.session-prolong-body',
    defaultMessage: 'Your editing session is about to expire. Would you like to extend it?',
    description: 'Edit reservation session prolong modal body text',
  },
  editSessionProlongExtend: {
    id: 'edit-reservation.session-prolong-extend',
    defaultMessage: 'Extend session',
    description: 'Edit reservation session prolong modal extend button',
  },
  editSessionProlongEnd: {
    id: 'edit-reservation.session-prolong-end',
    defaultMessage: 'End editing',
    description: 'Edit reservation session prolong modal end button',
  },
  editSessionProlongEnding: {
    id: 'edit-reservation.session-prolong-ending',
    defaultMessage: 'Finishing...',
    description: 'Edit reservation session prolong modal end button loading state',
  },
  editSessionProlongExtending: {
    id: 'edit-reservation.session-prolong-extending',
    defaultMessage: 'Extending...',
    description: 'Edit reservation session prolong modal extend button loading state',
  },
  editSessionProlongFailed: {
    id: 'edit-reservation.session-prolong-failed',
    defaultMessage: 'Failed to extend the session. Please try again.',
    description: 'Error when session prolong request fails',
  },
  editButtonCancelTitle: {
    id: 'edit-reservation.button-cancel',
    defaultMessage: 'Cancel',
    description: 'Edit reservation cancel button title',
  },
  editButtonCancelSubtitle: {
    id: 'edit-reservation.button-cancel-subtitle',
    defaultMessage: 'Discard changes',
    description: 'Edit reservation cancel button subtitle',
  },
  editButtonFinishTitle: {
    id: 'edit-reservation.button-finish',
    defaultMessage: 'Finish',
    description: 'Edit reservation finish button title',
  },
  editButtonFinishSubtitle: {
    id: 'edit-reservation.button-finish-subtitle',
    defaultMessage: 'Complete edit',
    description: 'Edit reservation finish button subtitle',
  },
  editButtonFinishing: {
    id: 'edit-reservation.button-finishing',
    defaultMessage: 'Finishing...',
    description: 'Edit reservation finishing in progress',
  },
  editErrorSavingTitle: {
    id: 'edit-reservation.error-saving-title',
    defaultMessage: 'Error Saving Changes',
    description: 'Edit reservation error saving title',
  },
  editReservationLoadNotFound: {
    id: 'edit-reservation.load-not-found',
    defaultMessage: "We couldn't find this reservation. Please check the link or contact our Customer Support.",
    description: 'Error shown when the reservation to edit cannot be found',
  },
  editNewSelectedDeparture: {
    id: 'edit-reservation.new-selected-departure',
    defaultMessage: 'New selected departure',
    description: 'Label shown after saving new departure time',
  },
  editConfirmWithFinish: {
    id: 'edit-reservation.confirm-with-finish',
    defaultMessage: 'To confirm the changes, press Finish',
    description: 'Hint shown after saving to press Finish button',
  },
  editBillingPreviouslyPaid: {
    id: 'edit-reservation.previously-paid',
    defaultMessage: 'Previously paid',
    description: 'Previously paid amount label',
  },
  editBillingPriceDifference: {
    id: 'edit-reservation.price-difference',
    defaultMessage: 'Price difference',
    description: 'Price difference label',
  },
  editBillingAdditionalPaymentBanner: {
    id: 'edit-reservation.additional-payment-banner',
    defaultMessage: 'To complete the changes, an additional payment of {amount} is required.',
    description: 'Banner shown when additional payment is required after modifying reservation',
  },
  editBillingRefundBanner: {
    id: 'edit-reservation.refund-banner',
    defaultMessage:
      '{amount} will be refunded to you using the same payment method you used when purchasing the ticket. Click the button below to confirm and continue.',
    description: 'Banner shown when a refund is due after modifying reservation',
  },
  editReservationRefundConfirmTitle: {
    id: 'edit-reservation.refund-confirm-title',
    defaultMessage: 'Your edits to ticket nr. {reservationId} are successfully saved',
    description: 'Heading on the refund confirmation page after editing a reservation',
  },
  editReservationRefundConfirmBody: {
    id: 'edit-reservation.refund-confirm-body',
    defaultMessage:
      'Difference in price ({amount}) will be returned to you by the means on Montonio, using same payment gateway that you chosen while purchasing the ticket(s)',
    description: 'Body text on the refund confirmation page — explains refund via Montonio',
  },
  editReservationRefundConfirmBack: {
    id: 'edit-reservation.refund-confirm-back',
    defaultMessage: 'Back to your tickets',
    description: 'CTA button label on refund confirmation page',
  },
  editTicketsOutboundLabel: {
    id: 'edit-reservation.tickets-outbound-label',
    defaultMessage: 'Outbound',
    description: 'Section header for outbound direction ticket editing',
  },
  editTicketsReturnLabel: {
    id: 'edit-reservation.tickets-return-label',
    defaultMessage: 'Return',
    description: 'Section header for return direction ticket editing',
  },
  editButtonFinishAndPayTitle: {
    id: 'edit-reservation.finish-and-pay-title',
    defaultMessage: 'Confirm',
    description: 'Finish button title when extra payment is required',
  },
  editButtonFinishAndPaySubtitle: {
    id: 'edit-reservation.finish-and-pay-subtitle',
    defaultMessage: 'And pay the difference',
    description: 'Finish button subtitle when extra payment is required',
  },
  editButtonFinishAndPayProcessing: {
    id: 'edit-reservation.finish-and-pay-processing',
    defaultMessage: 'Processing...',
    description: 'Finish button subtitle while committing with extra payment',
  },
  editReservationPaymentTitle: {
    id: 'edit-reservation.payment-title',
    defaultMessage: 'Complete payment for ticket nr. {reservationId}',
    description: 'Title on the extra payment page after editing a reservation',
  },
  editReservationPaymentBody: {
    id: 'edit-reservation.payment-body',
    defaultMessage: 'Your changes require an additional payment of {amount}',
    description: 'Body text showing the extra amount to pay',
  },
  editReservationPaymentButton: {
    id: 'edit-reservation.payment-button',
    defaultMessage: 'Pay {amount}',
    description: 'Pay button label with amount',
  },
  editReservationPaymentError: {
    id: 'edit-reservation.payment-error',
    defaultMessage: 'Payment could not be initiated. Please try again.',
    description: 'Error message when preparePayment fails',
  },
  editReservationPaymentButtonSubtitle: {
    id: 'edit-reservation.payment-button-subtitle',
    defaultMessage: 'to complete',
    description: 'Pay button subtitle in payment mode',
  },
  editReservationPaymentNoMethods: {
    id: 'edit-reservation.payment-no-methods',
    defaultMessage: 'Payment methods could not be loaded. Please try again.',
    description: 'Error message when payment methods failed to load',
  },
  editReservationCreditNeedsAccount: {
    id: 'edit-reservation.credit-needs-account',
    defaultMessage: 'Paying from a company account? Open editing from your account on the main site.',
    description:
      'Hint shown in the payment step when the credit method is unavailable because editing was opened directly by URL',
  },
  editReservationPaymentRetry: {
    id: 'edit-reservation.payment-retry',
    defaultMessage: 'Try again',
    description: 'Retry button after post-commit payment failure',
  },
  editPaymentCancelTitle: {
    id: 'edit-reservation.payment-cancel-title',
    defaultMessage: 'Cancel edits',
    description: 'Cancel button title in payment mode',
  },
  editPaymentCancelSubtitle: {
    id: 'edit-reservation.payment-cancel-subtitle',
    defaultMessage: 'and back to ticket',
    description: 'Cancel button subtitle in payment mode',
  },
  editErrorSailNotFound: {
    id: 'edit-reservation.error-sail-not-found',
    defaultMessage: 'The selected sailing is no longer available. Please choose another departure.',
    description: 'Error when the selected sailing no longer exists',
  },
  editUnsavedChangesTitle: {
    id: 'edit-reservation.unsaved-changes-title',
    defaultMessage: 'You have unsaved changes',
    description: 'Unsaved changes confirmation dialog title',
  },
  editUnsavedChangesBody: {
    id: 'edit-reservation.unsaved-changes-body',
    defaultMessage: 'If you leave this tab, your unsaved changes will be discarded.',
    description: 'Unsaved changes confirmation dialog body',
  },
  editUnsavedChangesStay: {
    id: 'edit-reservation.unsaved-changes-stay',
    defaultMessage: 'Stay',
    description: 'Stay on current tab button in unsaved changes dialog',
  },
  editUnsavedChangesDiscard: {
    id: 'edit-reservation.unsaved-changes-discard',
    defaultMessage: 'Leave',
    description: 'Leave button in unsaved changes dialog',
  },
  editErrorNoPassengerSeats: {
    id: 'edit-reservation.error-no-passenger-seats',
    defaultMessage: 'Not enough passenger seats available',
    description: 'Error when backend returns FAILED_TO_ALLOCATE_PAX_INVENTORY',
  },
  editErrorNoVehicleSpace: {
    id: 'edit-reservation.error-no-vehicle-space',
    defaultMessage: 'No vehicle space available',
    description: 'Error when backend returns FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY',
  },
  editErrorWeightBelowCurb: {
    id: 'edit-reservation.error-weight-below-curb',
    defaultMessage: "The entered weight is below the vehicle's kerb mass",
    description: 'Error when backend returns CURB_WEIGHT_VIOLATION for a hand-corrected vehicle weight',
  },
  editErrorNoBicycleSpace: {
    id: 'edit-reservation.error-no-bicycle-space',
    defaultMessage: 'No bicycle space available',
    description:
      'Warning from the client-side inventory pre-check when a picked sail lacks bicycle capacity. Not driven by a backend error code — bicycle allocation failures come back as FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY',
  },
  editErrorExcludedPrice: {
    id: 'edit-reservation.error-excluded-price',
    defaultMessage: 'This ticket type is not available on the selected sailing',
    description: 'Error when backend returns EXCLUDED_PRICE_CATEGORY',
  },
  vehicleCategoryExcluded: {
    id: 'vehicleCategoryExcluded',
    defaultMessage: 'You cannot buy a ticket for a vehicle of this category for this sail',
    description:
      'Shown when the vehicle register lookup (Kihnu) resolved a category the sailing does not sell through this channel, and when changing the sail of a leg with a vehicle fails with EXCLUDED_PRICE_CATEGORY (useRouteEditState)',
  },
  editErrorAllItemsRemoved: {
    id: 'edit-reservation.error-all-items-removed',
    defaultMessage:
      'A reservation must include at least one ticket. To remove all tickets, please cancel the reservation instead.',
    description: 'Error when backend returns RESERVATION_REMOVED_ALL_ITEMS',
  },
  editErrorRoutePrefix: {
    id: 'edit-reservation.error-route-prefix',
    defaultMessage: '{route}: {message}',
    description: 'Error message prefixed with route name',
  },
  editErrorCancelFailed: {
    id: 'edit-reservation.error-cancel-failed',
    defaultMessage: 'Failed to cancel changes',
    description: 'Error when reverting reservation changes fails',
  },
  editErrorPassengerResolve: {
    id: 'edit-reservation.error-passenger-resolve',
    defaultMessage: 'Unable to resolve passenger record for update',
    description: 'Error when passenger guest record cannot be found',
  },
  editErrorFinishFailed: {
    id: 'edit-reservation.error-finish-failed',
    defaultMessage: 'Failed to finalize changes',
    description: 'Error when committing reservation changes fails',
  },
  editErrorSaveCustomerFailed: {
    id: 'edit-reservation.error-save-customer-failed',
    defaultMessage: 'Failed to save customer data',
    description: 'Error when saving passenger info fails',
  },
  editErrorStalePageReloading: {
    id: 'edit-reservation.error-stale-page-reloading',
    defaultMessage: 'This page is out of date. Reloading to continue.',
    description: 'Shown when an outdated page calls a stale Server Action id',
  },
  editSailCancelledTicketsDisabled: {
    id: 'edit-reservation.sail-cancelled-tickets-disabled',
    defaultMessage: 'This sail has been cancelled. To edit tickets, select a new sailing date first.',
    description: 'Toast shown when user clicks on disabled tickets area for a cancelled sail',
  },
  usersTabSelectCompany: {
    id: 'users-tab.select-company',
    defaultMessage: 'Select company',
    description: 'Label for company selector in users tab',
  },
  usersTabNoMembers: {
    id: 'users-tab.no-members',
    defaultMessage: 'No members found',
    description: 'Message when no members found in users tab',
  },
  usersTabInviteButton: {
    id: 'users-tab.invite-button',
    defaultMessage: 'Invite user',
    description: 'Button label to open invite form in users tab',
  },
  usersTabEmail: {
    id: 'users-tab.email',
    defaultMessage: 'Email address',
    description: 'Email field label in users tab invite form',
  },
  usersTabPersonalId: {
    id: 'users-tab.personal-id',
    defaultMessage: 'Personal ID number',
    description: 'Personal ID field label in users tab invite form',
  },
  usersTabInviteSubmit: {
    id: 'users-tab.invite-submit',
    defaultMessage: 'Send invitation',
    description: 'Submit button label in users tab invite form',
  },
  usersTabManager: {
    id: 'users-tab.manager',
    defaultMessage: 'Main',
    description: 'Role label for manager in users tab',
  },
  usersTabActive: {
    id: 'users-tab.active',
    defaultMessage: 'Common',
    description: 'Status label for active member in users tab',
  },
  usersTabInactive: {
    id: 'users-tab.inactive',
    defaultMessage: 'Inactive',
    description: 'Status label for inactive member in users tab',
  },
  usersTabPendingInvitation: {
    id: 'users-tab.pending-invitation',
    defaultMessage: 'Pending',
    description: 'Section title for pending invitations in users tab',
  },
  usersTabActivate: {
    id: 'users-tab.activate',
    defaultMessage: 'Activate',
    description: 'Button label to activate a member in users tab',
  },
  usersTabDeactivate: {
    id: 'users-tab.deactivate',
    defaultMessage: 'Deactivate',
    description: 'Button label to deactivate a member in users tab',
  },
  usersTabRemoveMember: {
    id: 'users-tab.remove-member',
    defaultMessage: 'Remove user',
    description: 'Button label to remove a member in users tab',
  },
  usersTabRemoveMemberShort: {
    id: 'users-tab.remove-member-short',
    defaultMessage: 'Remove',
    description: 'Short button label to remove a member on the member card',
  },
  usersTabResendInvite: {
    id: 'users-tab.resend-invite',
    defaultMessage: 'Resend',
    description: 'Button label to resend an invitation in users tab',
  },
  usersTabCancelInvite: {
    id: 'users-tab.cancel-invite',
    defaultMessage: 'Cancel invite',
    description: 'Button label to cancel a pending invitation in users tab',
  },
  usersTabMonthlyCredit: {
    id: 'users-tab.monthly-credit',
    defaultMessage: 'Monthly credit',
    description: 'Label for monthly credit available/limit in users tab',
  },
  usersTabViewTickets: {
    id: 'users-tab.view-tickets',
    defaultMessage: 'View tickets',
    description: 'Button label to view a member tickets in users tab',
  },
  usersTabHideTickets: {
    id: 'users-tab.hide-tickets',
    defaultMessage: 'Hide tickets',
    description: 'Button label to collapse tickets in users tab',
  },
  usersTabAddUser: {
    id: 'users-tab.add-user',
    defaultMessage: 'Add new user',
    description: 'Button label to open invite form in users tab',
  },
  usersTabEdit: {
    id: 'users-tab.edit',
    defaultMessage: 'Edit',
    description: 'Button label to edit own profile from users tab',
  },
  usersTabYou: {
    id: 'users-tab.you',
    defaultMessage: '(You)',
    description: 'Label shown next to the current user name in the users tab',
  },
  usersTabBackToUsers: {
    id: 'users-tab.back-to-users',
    defaultMessage: 'Back to users',
    description: 'Back link from tickets view to members list',
  },
  usersTabSelectUser: {
    id: 'users-tab.select-user',
    defaultMessage: 'User',
    description: 'Label for user selector in tickets view',
  },
  usersTabAllUsers: {
    id: 'users-tab.all-users',
    defaultMessage: 'All users',
    description: 'Default option in user selector showing tickets for all users',
  },
  usersTabAllCompanies: {
    id: 'users-tab.all-companies',
    defaultMessage: 'All companies',
    description: 'Option in company selector showing tickets across all managed companies',
  },
  usersTabRemoveConfirmTitle: {
    id: 'users-tab.remove-confirm-title',
    defaultMessage: 'Remove user',
    description: 'Title of the remove user confirmation modal',
  },
  usersTabRemoveConfirmCancel: {
    id: 'users-tab.remove-confirm-cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button in the remove user confirmation modal',
  },
  usersTabInviteModalTitle: {
    id: 'users-tab.invite-modal-title',
    defaultMessage: 'Send invitation to new user',
    description: 'Title of the invite user modal',
  },
  usersTabInviteHowItWorksTitle: {
    id: 'users-tab.invite-how-it-works-title',
    defaultMessage: 'How it works?',
    description: 'Title of the how it works section in invite modal',
  },
  usersTabInviteStep1: {
    id: 'users-tab.invite-step-1',
    defaultMessage:
      "Step 1 — You're sending invitation to new user's email (you're here now). Please, double-check that you typed email correctly!",
    description: 'Step 1 description in the invite modal',
  },
  usersTabInviteStep2: {
    id: 'users-tab.invite-step-2',
    defaultMessage:
      'Step 2 — New user receives the email and clicks to special link to be added as your new user. Then new user fills some data about himself, as Name, phone number etc.',
    description: 'Step 2 description in the invite modal',
  },
  usersTabDeactivateConfirmTitle: {
    id: 'users-tab.deactivate-confirm-title',
    defaultMessage: 'Deactivate user',
    description: 'Title of the deactivate user confirmation modal',
  },
  usersTabDeactivateConfirmWarningTitle: {
    id: 'users-tab.deactivate-confirm-warning-title',
    defaultMessage: 'PLEASE, BE NOTED, THAT:',
    description: 'Warning section title in the deactivate confirmation modal',
  },
  usersTabDeactivateConfirmBullet1: {
    id: 'users-tab.deactivate-confirm-bullet-1',
    defaultMessage:
      "This user will be marked as inactive in your users list, and when you're sure, you may completely remove it from the list.",
    description: 'First warning bullet in the deactivate confirmation modal',
  },
  usersTabDeactivateConfirmBullet2: {
    id: 'users-tab.deactivate-confirm-bullet-2',
    defaultMessage: "This user will not be able to use company's credit amount or buy tickets to the company's name.",
    description: 'Second warning bullet in the deactivate confirmation modal',
  },
  usersTabDeactivateConfirmBullet3: {
    id: 'users-tab.deactivate-confirm-bullet-3',
    defaultMessage:
      'All information about purchased tickets will be still accessible both from you and this user sides, as well as delete operations. It means that if one of you will prefer to delete old ticket, both of you may lose access to it.',
    description: 'Third warning bullet in the deactivate confirmation modal',
  },
  usersTabDeactivateConfirmBullet4: {
    id: 'users-tab.deactivate-confirm-bullet-4',
    defaultMessage: 'You can always re-activate user back again.',
    description: 'Fourth warning bullet in the deactivate confirmation modal',
  },
  usersTabDeactivateConfirmAgree: {
    id: 'users-tab.deactivate-confirm-agree',
    defaultMessage: 'Sounds good, I agree',
    description: 'Checkbox label in the deactivate confirmation modal',
  },
  usersTabDeactivateConfirmButton: {
    id: 'users-tab.deactivate-confirm-button',
    defaultMessage: 'Deactivate user',
    description: 'Confirm button in the deactivate confirmation modal',
  },
  usersTabDeactivateConfirmCancel: {
    id: 'users-tab.deactivate-confirm-cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button in the deactivate confirmation modal',
  },
  joinPageTitle: {
    id: 'join-page.title',
    defaultMessage: 'Create corporate account',
    description: 'Title of the join/invitation page',
  },
  joinPageInvalidToken: {
    id: 'join-page.invalid-token',
    defaultMessage: 'This invitation link is invalid or has expired.',
    description: 'Error shown when invitation token is invalid',
  },
  joinPageError: {
    id: 'join-page.error',
    defaultMessage: 'Failed to accept the invitation. Please try again.',
    description: 'Error shown when invitation acceptance fails',
  },
  joinPageSuccess: {
    id: 'join-page.success',
    defaultMessage: 'You have successfully joined the company.',
    description: 'Success message after joining a company',
  },
  joinPageInfoTitle: {
    id: 'join-page.info-title',
    defaultMessage: 'You have been invited',
    description: 'Info block title on the join page',
  },
  joinPageInfoText: {
    id: 'join-page.info-text',
    defaultMessage: 'Sign in with your Estonian ID method to accept the invitation and join the corporate account.',
    description: 'Info block description on the join page',
  },
  idSignupFormTitle: {
    id: 'id-signup.form-title',
    defaultMessage: 'CREATE COMPANY ACCOUNT',
    description: 'Title of company registration form after ID authentication',
  },
  idSignupFormSubtitle: {
    id: 'id-signup.form-subtitle',
    defaultMessage: 'PLEASE ENTER THE FOLLOWING INFORMATION:',
    description: 'Subtitle of company registration form',
  },
  idSignupFormIdCode: {
    id: 'id-signup.form-id-code',
    defaultMessage: 'ID-kood',
    description: 'Personal identification code field label',
  },
  idSignupFormInfoTitle: {
    id: 'id-signup.form-info-title',
    defaultMessage: 'Some important aspects:',
    description: 'Info block title on company registration form',
  },
  idSignupFormInfoText1: {
    id: 'id-signup.form-info-text-1',
    defaultMessage:
      'If you already have an account on our website and use the same email address here, the company profile will be added to your existing account. You will still be able to buy tickets the same way as before, but in addition you will be able to buy tickets through your company account.',
    description: 'First info paragraph on company registration form',
  },
  idSignupFormInfoText2: {
    id: 'id-signup.form-info-text-2',
    defaultMessage:
      'If you are creating an account on our website for the first time, with this user account you can pay for your tickets through a company or personal account by selecting a role.',
    description: 'Second info paragraph on company registration form',
  },
  idSignupFormError: {
    id: 'id-signup.form-error',
    defaultMessage: 'Failed to create account. Please try again.',
    description: 'Error message on company registration form',
  },
  idSignupFormLoading: {
    id: 'id-signup.form-loading',
    defaultMessage: 'Loading your details…',
    description: 'Loading state message on company registration form',
  },
  usersTabLabelCompany: {
    id: 'users-tab.label-company',
    defaultMessage: 'Company',
    description: 'Company label in remove user confirmation modal',
  },
  usersTabLabelFirstName: {
    id: 'users-tab.label-first-name',
    defaultMessage: 'First name',
    description: 'First name label in remove user confirmation modal',
  },
  usersTabLabelSurname: {
    id: 'users-tab.label-surname',
    defaultMessage: 'Surname',
    description: 'Surname label in remove user confirmation modal',
  },
  usersTabLabelIdCode: {
    id: 'users-tab.label-id-code',
    defaultMessage: 'ID code',
    description: 'ID code label in remove user confirmation modal',
  },
  usersTabLabelPhone: {
    id: 'users-tab.label-phone',
    defaultMessage: 'Phone',
    description: 'Phone label in remove user confirmation modal',
  },
  usersTabLabelEmail: {
    id: 'users-tab.label-email',
    defaultMessage: 'Email',
    description: 'Email label in remove user confirmation modal',
  },
  vehicleCardTitle: {
    id: 'vehicleCardTitle',
    defaultMessage: 'Vehicle',
    description: 'Title of the vehicle ticket card',
  },
  trailerCardTitle: {
    id: 'trailerCardTitle',
    defaultMessage: 'Trailer',
    description: 'Title of the trailer ticket card',
  },
  vehicleCardSubtitle: {
    id: 'vehicleCardSubtitle',
    defaultMessage: 'One vehicle per booking',
    description: 'Subtitle of the vehicle ticket card',
  },
  trailerCardSubtitle: {
    id: 'trailerCardSubtitle',
    defaultMessage: 'One trailer per booking — can be added without a vehicle',
    description: 'Subtitle of the trailer ticket card',
  },
  vehicleAddTile: {
    id: 'vehicleAddTile',
    defaultMessage: 'Add a vehicle',
    description: 'Collapsed tile that opens the vehicle form',
  },
  trailerAddTile: {
    id: 'trailerAddTile',
    defaultMessage: 'Add a trailer',
    description: 'Collapsed tile that opens the trailer form',
  },
  vehiclePlateLabel: {
    id: 'vehiclePlateLabel',
    defaultMessage: 'Registration number',
    description: 'Label of the registration plate input, same for the vehicle and trailer cards',
  },
  vehiclePlatePlaceholder: {
    id: 'vehiclePlatePlaceholder',
    defaultMessage: 'Licence plate number',
    description: 'Placeholder of the registration plate input, same for both cards',
  },
  vehicleCategoryLabel: {
    id: 'vehicleCategoryLabel',
    defaultMessage: 'Ticket category',
    description: 'Label of the manual ticket-category select',
  },
  vehicleChooseType: {
    id: 'vehicleChooseType',
    defaultMessage: 'Choose vehicle type',
    description: 'Placeholder option of the manual ticket-category select',
  },
  vehicleWidthLabel: {
    id: 'vehicleWidthLabel',
    defaultMessage: 'Width',
    description: 'Label for the vehicle width field',
  },
  vehicleHeightLabel: {
    id: 'vehicleHeightLabel',
    defaultMessage: 'Height',
    description: 'Label for the vehicle height field',
  },
  vehicleLengthLabel: {
    id: 'vehicleLengthLabel',
    defaultMessage: 'Length (m)',
    description: 'Label for the vehicle length field',
  },
  vehicleWeightLabel: {
    id: 'vehicleWeightLabel',
    defaultMessage: 'Weight (t)',
    description: 'Label for the vehicle weight field',
  },
  vehicleWidthS: {
    id: 'vehicleWidthS',
    defaultMessage: 'less than 2 m',
    description: 'Vehicle width option: small',
  },
  vehicleWidthM: {
    id: 'vehicleWidthM',
    defaultMessage: 'from 2 m to 2.6 m',
    description: 'Vehicle width option: medium',
  },
  vehicleWidthL: {
    id: 'vehicleWidthL',
    defaultMessage: 'more than 2.6 m',
    description: 'Vehicle width option: large',
  },
  vehicleHeightS: {
    id: 'vehicleHeightS',
    defaultMessage: 'less than 4 m',
    description: 'Vehicle height option: small',
  },
  vehicleHeightL: {
    id: 'vehicleHeightL',
    defaultMessage: 'more than 4 m',
    description: 'Vehicle height option: large',
  },
  vehicleLengthRangeHint: {
    id: 'vehicleLengthRangeHint',
    defaultMessage: 'min 5 m / max 30 m',
    description: 'Allowed range hint for the vehicle length input',
  },
  vehicleWeightRangeHint: {
    id: 'vehicleWeightRangeHint',
    defaultMessage: 'min 2 t / max 70 t',
    description: 'Allowed range hint for the vehicle weight input',
  },
  vehicleLengthDecrease: {
    id: 'vehicleLengthDecrease',
    defaultMessage: 'Decrease length',
    description: 'Accessible name of the length stepper minus button',
  },
  vehicleLengthIncrease: {
    id: 'vehicleLengthIncrease',
    defaultMessage: 'Increase length',
    description: 'Accessible name of the length stepper plus button',
  },
  vehicleWeightDecrease: {
    id: 'vehicleWeightDecrease',
    defaultMessage: 'Decrease weight',
    description: 'Accessible name of the weight stepper minus button',
  },
  vehicleWeightIncrease: {
    id: 'vehicleWeightIncrease',
    defaultMessage: 'Increase weight',
    description: 'Accessible name of the weight stepper plus button',
  },
  vehicleSpecType: {
    id: 'vehicleSpecType',
    defaultMessage: 'Type',
    description: 'Key of the registry vehicle-category chip',
  },
  vehicleSpecLength: {
    id: 'vehicleSpecLength',
    defaultMessage: 'Length',
    description: 'Key of the registry length chip',
  },
  vehicleSpecWidth: {
    id: 'vehicleSpecWidth',
    defaultMessage: 'Width',
    description: 'Key of the registry width chip',
  },
  vehicleSpecHeight: {
    id: 'vehicleSpecHeight',
    defaultMessage: 'Height',
    description: 'Key of the registry height chip',
  },
  vehicleSpecWeight: {
    id: 'vehicleSpecWeight',
    defaultMessage: 'Weight',
    description: 'Key of the registry weight chip',
  },
  vehicleManualSummaryTitle: {
    id: 'vehicleManualSummaryTitle',
    defaultMessage: 'Your vehicle details:',
    description: 'Title of the green panel restating the dimensions typed into the manual vehicle form',
  },
  trailerManualSummaryTitle: {
    id: 'trailerManualSummaryTitle',
    defaultMessage: 'Your trailer details:',
    description: 'Title of the green panel restating the dimensions typed into the manual trailer form',
  },
  vehicleAddTicket: {
    id: 'vehicleAddTicket',
    defaultMessage: 'Add',
    description: 'Button to confirm and add the vehicle/trailer ticket, followed by the total price',
  },
  vehicleSaveTicket: {
    id: 'vehicleSaveTicket',
    defaultMessage: 'Save',
    description: 'Button that saves the edited vehicle/trailer ticket, followed by the total price',
  },
  vehicleRemoveTicket: {
    id: 'vehicleRemoveTicket',
    defaultMessage: 'Remove',
    description: 'Button to remove an already-added vehicle/trailer ticket',
  },
  vehicleCancel: {
    id: 'vehicleCancel',
    defaultMessage: 'Cancel',
    description: 'Button that discards the vehicle/trailer form and collapses the card',
  },
  vehicleEdit: {
    id: 'vehicleEdit',
    defaultMessage: 'Edit',
    description: 'Button that reopens the form of an already-added vehicle/trailer',
  },
  vehicleNoDeckSpace: {
    id: 'vehicleNoDeckSpace',
    defaultMessage: 'Sorry! There is not enough space on the vessel.',
    description: 'Shown when there is no remaining deck space for the vehicle/trailer',
  },
}
